import React, { useEffect, useRef, useState } from 'react'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getCategoryListingPaginate, getManufacturesListing, getManufacturesListingPaginate, getStoresListing, getSubCategoryDetails, getSubCategoryListingPaginate, updateManufacturer } from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup';
import { useFormik } from 'formik';
import { IoMdArrowBack, IoMdCloseCircleOutline } from 'react-icons/io'
import { getCategoryListing } from '../../api/context/category'
import { getSubCategoryListing } from '../../api/context/subcategory'
import { BiPlus } from "react-icons/bi";
import upload from '../../assets/images/Paper Upload.png'
import Select from 'react-select'
import { aiFillerProduct, createProducts, deleteProductImage, getProductsDetails, updateProducts } from '../../api/context/products';
import imageToBase64 from 'image-to-base64/browser';
import { SketchPicker } from 'react-color';
import AsyncSelect from 'react-select/async';
import { IoClose } from 'react-icons/io5';
import { MdDeleteOutline } from "react-icons/md";
import * as Yup from 'yup';
import { getBrandListing } from '../../api/context/brand';
import CircularProgress from '@mui/material/CircularProgress';
import { errorSelector } from 'recoil';
import Loader from '../../components/loader/loader';
import { FiPlus, FiUploadCloud } from 'react-icons/fi';
import { LuCheckCheck } from 'react-icons/lu';
import { FaWandMagicSparkles } from 'react-icons/fa6';
import { RiSparkling2Fill } from 'react-icons/ri';


const CreateInventory = () => {


    const navigate = useNavigate()
    const colorPickerRef = useRef();
    const descriptionEditorRef = useRef(null);

    const { state } = useLocation();

    const variantedit = state?.type;

    const { id } = useParams()

    const user = JSON.parse(localStorage.getItem('user'));

    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [update, setUpdate] = useState(false);
    const [store, setStore] = useState([]);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    const [subsubcategory, setSubSubCategory] = useState([]);
    const [specificationDrpdwn, setSpecificationDrpDwn] = useState([]);
    const [manufacturers, setManufacturers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [oldImages, setOldImages] = useState([]);
    const [oldVariantImages, setOldVariantImages] = useState([]);
    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedColorVariant, setSelectedColorVariant] = useState('');
    const [showSpecification, setShowSpecification] = useState(false)
    const [showVariantSpecification, setShowVariantSpecification] = useState(false)
    const [specicTypes, setSpecificTypes] = useState([])
    const [specificChange, setSpecificChange] = useState()
    const [variantspecificChange, setVariantSpecificChange] = useState()

    const [page, setPage] = useState(1); // Current page for API pagination
    const [hasMore, setHasMore] = useState(true); // To track if more data is available

    const [pagemanufacture, setPageManufacture] = useState(1);
    const [hasMoreManufacture, setHasMoreManufacture] = useState(true);

    const [thumbnailIndex, setThumbnailIndex] = useState(0);
    const [isOldImageThumbnail, setIsOldImageThumbnail] = useState(true);
    const [thumbnailImageUrl, setThumbnailImageUrl] = useState('');

    const [tags, setTags] = useState([]);
    const [isAiGenerated, setIsAiGenerated] = useState(false);
    const [aiEstimatedPrice, setAiEstimatedPrice] = useState(null);
    const [aiEstimatedDiscountedPrice, setAiEstimatedDiscountedPrice] = useState(null);
    const [isPublished, setIsPublished] = useState(true);

    const handleThumbnailSelect = (index, isOldImage = false) => {
        setThumbnailIndex(index);
        setIsOldImageThumbnail(isOldImage);

        if (isOldImage && oldImages[index]) {

            console.log("Old image selected for thumbnail:", oldImages[index]);
            // Store backend value in formik
            const s3Key = getS3KeyFromUrl(oldImages[index].imageUrl);
            formik.setFieldValue("thumbnailImageUrl", s3Key);
            console.log("S3 Key set in formik:", s3Key);

            // Store preview URL separately
            setThumbnailImageUrl(oldImages[index].imageUrl);
            console.log("Thumbnail preview URL set to old image URL:", oldImages[index].imageUrl);
        } else if (!isOldImage && formik.values.images[index]) {
            const img = formik.values.images[index];

            // Store backend value in formik
            formik.setFieldValue("thumbnailImageUrl", img);

            // Store preview URL separately
            const previewUrl = typeof img === "string" ? img : URL.createObjectURL(img);
            setThumbnailImageUrl(previewUrl);
        }
    };




    const handleShow = () => setShow(true);
    const handleSpecification = () => setShowSpecification(true)

    const handleVariantSpecification = () => {
        setShowVariantSpecification(true)
        setShow(false)
    }


    const handleClose = () => {
        setShowSpecification(false)
        setShow(false);
        variantformik.resetForm({
            values: {
                variantName: '',
                variantColor: '',
                variantPrice: '',
                variantDiscountedPrice: '',
                variantStock: '',
                specs: [{ name: '', value: '' }],
                variantImages: [],
                variantSizes: [
                    {
                        sizes: [{ size: '', stock: '' }]
                    }
                ],
            },
        });
    };

    const handleSpecificationClose = () => {
        setShowVariantSpecification(false)
        setShow(true)
    };

    const cancelStore = () => {
        navigate(-1)
    }


    const addImageFiles = async (files) => {
        const valid = (files || []).filter((f) => f && f.type && f.type.startsWith('image/'));
        if (!valid.length) return;
        const images = await Promise.all(
            valid.map(async (file) => {
                try {
                    const response = await imageToBase64(URL.createObjectURL(file));
                    return `data:image/jpeg;base64,${response}`;
                } catch (error) {
                    return null;
                }
            })
        );
        const successful = images.filter(Boolean);
        if (!successful.length) return;

        const currentImages = formik.values.images || [];
        const nextImages = [...currentImages, ...successful];
        const hadThumbnail = !!formik.values.thumbnailImageUrl;

        const updates = { ...formik.values, images: nextImages };

        // Auto-select the first newly-added image as thumbnail when nothing was set yet.
        // Covers: fresh create (no old images, no thumbnail), and edit mode where the product
        // had no thumbnail — a vendor's very first upload becomes the thumbnail automatically.
        if (!hadThumbnail && (oldImages?.length || 0) === 0 && currentImages.length === 0) {
            const firstImg = successful[0];
            updates.thumbnailImageUrl = firstImg;
            setThumbnailImageUrl(firstImg);
            setThumbnailIndex(0);
            setIsOldImageThumbnail(false);
        }
        formik.setValues(updates);
    };

    const handleImageChange = async (e) => {
        const files = Array.from(e?.target?.files || []);
        await addImageFiles(files);
        if (e?.target) e.target.value = null;
    }

    // Drag & drop for the product-images card
    const [isDraggingImages, setIsDraggingImages] = useState(false);
    const dragCounterRef = useRef(0);

    const handleImageDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e?.dataTransfer?.types?.includes('Files')) {
            dragCounterRef.current += 1;
            setIsDraggingImages(true);
        }
    };
    const handleImageDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e?.dataTransfer) e.dataTransfer.dropEffect = 'copy';
    };
    const handleImageDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounterRef.current = Math.max(0, dragCounterRef.current - 1);
        if (dragCounterRef.current === 0) setIsDraggingImages(false);
    };
    const handleImageDrop = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounterRef.current = 0;
        setIsDraggingImages(false);
        const files = Array.from(e?.dataTransfer?.files || []);
        if (files.length) await addImageFiles(files);
    };

    const handleImageVariantChange = async (e) => {
        const files = Array.from(e?.target?.files);


        const images = await Promise.all(
            files.map(async (file) => {
                try {
                    const response = await imageToBase64(URL.createObjectURL(file));
                    return `data:image/jpeg;base64,${response}`;
                } catch (error) {
                    return null;
                }
            })
        );

        variantformik.setValues({
            ...variantformik.values,
            variantImages: [...(variantformik.values.variantImages || []), ...images],
        });
        e.target.value = null;
    }




    const validationSchema = yup.object().shape({

        productName: yup
            .string()
            .matches(/^(?!\s*$)[^\s].*$/, 'Product name cannot be blank or contain only spaces')
            .required('Product name is required'),
        subCategoryId: yup
            .string('')
            .required('Category is required'),
        subSubCategoryId: yup
            .string('')
            .required('Sub category is required'),
        manufacturerId: user?.userType !== "Vendor"
            ? yup.string().required('Required')
            : yup.string(),
        description: yup
            .string('')
            .required('Description is required'),
        color: yup
            .string('')
            .required('Color is required'),
        stock: yup
            .string('')
            .matches(/^[0-9]+$/, 'Enter a valid stock')
            .required('Stock is required'),
        images: id ? yup.array() : yup.array().min(1).required("Required"),


        price: yup
            .string()
            .required('Price is required')
            .test(
                'is-greater-than-zero',
                'Price must be greater than 0',
                (value) => value == null || value === '' || parseFloat(value) > 0
            ),
        discountedPrice: yup
            .string()
            .required('Discounted price is required')
            .test(
                'is-greater-than-zero',
                'Discounted price must be greater than 0',
                (value) => value == null || value === '' || parseFloat(value) > 0
            )
            .test(
                'is-less-than-price',
                'Discounted price must be less than price',
                function (value) {
                    const price = this.parent.price;
                    if (!price || !value) return true; // Skip validation if either field is empty
                    return parseFloat(value) <= parseFloat(price);
                }
            ),

        sizes: yup
            .array()
            .of(
                yup.object().shape({
                    size: yup.string().required('Size is required'),
                    stock: yup
                        .string()
                        .matches(/^[0-9]+$/, 'Enter a valid stock')
                        .required('Stock is required'),
                })
            )
            .min(1, 'At least one size must be added')
            .required('Sizes are required'),
        thumbnailImageUrl: yup.string(),


    });

    const formik = useFormik({
        initialValues: {
            subCategoryId: '',
            selectedCategory: '',
            subSubCategoryId: '',
            selectedSubCategory: '',
            manufacturerId: '',
            selectedManufacture: '',
            brandId: '',
            selectedBrand: '',
            productName: '',
            description: '',
            isProductVariant: false,
            stock: '',
            color: '',
            price: '',
            discountedPrice: '',
            sizes: [],
            specs: [],
            images: [],
            variants: [],
            tags: [],
            thumbnailImageUrl: '',
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {};

            if (!values.selectedCategory) {
                errors.selectedCategory = "Category is required";
            }
            if (!values.selectedSubCategory) {
                errors.selectedSubCategory = "Sub category is required";
            }
            if (user?.userType !== "Vendor") {
                if (!values.selectedManufacture) {
                    errors.selectedManufacture = "Vendor is required";
                }
            }
            if (!values.selectedBrand) {
                errors.selectedBrand = "Brand is required";
            }

            // ✅ Image validation — at least one image required (old or new combined)
            const totalImages =
                (oldImages?.length || 0) + (values.images?.length || 0);
            if (totalImages < 1) {
                errors.images = "At least one product image is required";
            }

            // ✅ Sizes/stock validation — total stock must be > 0 for:
            //    • Create mode (no id)
            //    • Publishing an AI draft (Add to Inventory)
            const isPublishingAiDraft = id && isAiGenerated && !isPublished;
            if (!id || isPublishingAiDraft) {
                const totalStock = (values.sizes || []).reduce(
                    (sum, s) => sum + (parseInt(s?.stock, 10) || 0),
                    0
                );
                if (totalStock <= 0) {
                    errors.sizes = isPublishingAiDraft
                        ? "Add stock for at least one size before adding to inventory"
                        : "Add stock for at least one size before saving";
                }
            }

            return errors;
        },

        onSubmit: async (values, { resetForm }) => {

            console.log("Formik onSubmit called", values);

            setLoading(true);

            values.manufacturerId = user?.vendorId ? user?.vendorId : values.manufacturerId;

            try {
                if (id) {

                    const wasAddingToInventory = isAiGenerated && !isPublished;

                    updateProducts(values)((response) => {
                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success(
                                wasAddingToInventory
                                    ? "Product added to inventory successfully"
                                    : "Product Updated Successfully"
                            );
                            if (wasAddingToInventory) {
                                navigate('/inventory');
                            } else {
                                navigate(-1);
                            }
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })

                }
                else {

                    createProducts(values)((response) => {

                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("Product Created Successfully")
                            navigate(-1);
                        } else {

                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })
                }
            } catch (error) {
                setLoading(false);
            }
        },

    });

    // Scroll to first errored section on submit
    useEffect(() => {
        if (!formik.submitCount) return;
        try {
            const errors = formik.errors || {};
            if (!errors || typeof errors !== 'object') return;
            const errorKeys = Object.keys(errors);
            if (errorKeys.length === 0) return;
            const fieldToAnchor = { sizes: 'field-sizes', images: 'field-images' };
            let target = null;
            for (const key of errorKeys) {
                const anchor = fieldToAnchor[key];
                if (anchor) {
                    target = document.getElementById(anchor);
                } else {
                    const el = document.querySelector(`[name="${key}"]`);
                    if (el) target = el.closest('.form-group') || el.closest('.card') || el;
                }
                if (target) break;
            }
            if (target && typeof target.scrollIntoView === 'function') {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } catch (e) {
            /* no-op */
        }
    }, [formik.submitCount]);

    const variantformik = useFormik({
        initialValues: {
            variantName: '',
            variantColor: '',
            variantPrice: '',
            variantDiscountedPrice: '',
            variantStock: '',
            // specs: [],
            specs: [
                { name: '', value: '' }
            ],
            variantImages: [],
            variantSizes: [
                {
                    sizes: [
                        { size: '', stock: '' }
                    ]
                }
            ],

        },
        validationSchema: Yup.object().shape({
            variantName: Yup.string().required('Required'),
            variantColor: Yup.string().required('Required'),
            variantStock: Yup.string().required('Required'),
            variantPrice: Yup.string().required('Required'),
            variantImages: id ? yup.array() : yup.array().min(1).required("Required"),
            variantSizes: yup
                .array()
                .of(
                    yup.object().shape({
                        sizes: yup
                            .array()
                            .of(
                                yup.object().shape({
                                    size: yup.string().required('Size is required'),
                                    stock: yup
                                        .string()
                                        .matches(/^[0-9]+$/, 'Enter a valid stock')
                                        .required('Stock is required'),
                                })
                            )
                            .min(1, 'At least one size must be added')
                            .required('Sizes are required'),
                    })
                )
                .min(1, 'At least one variant size group is required')
                .required('Variant sizes are required'),


        }),
        // validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            addVariant(values);
        },

    });


    const addVariant = (variantValues) => {

        let variant = formik.values.variants;
        variant.push(variantValues)

        formik.setValues({
            ...formik.values,
            variants: variant,
        });
        handleClose();
        setLoading(false);
        variantformik.resetForm({
            values: {
                variantName: '',
                variantColor: '',
                variantPrice: '',
                variantDiscountedPrice: '',
                variantStock: '',
                specs: [{ name: '', value: '' }],
                variantImages: [],
                variantSizes: [
                    {
                        sizes: [{ size: '', stock: '' }]
                    }
                ],
            },
        });
    };



    const handleAddSize = () => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Add a new size and stock object to the sizes array
        updatedVariantSizes[0].sizes.push({ size: '', stock: '' });

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);
    };

    const handleVariantSpecificationAdd = () => {
        const updatedVariantSpecifications = [...variantformik.values.specs];

        updatedVariantSpecifications.push({ name: '' });

        variantformik.setFieldValue('specs', updatedVariantSpecifications);
    };

    const handleSizeSelectChange = (index, selectedOption) => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Update the size value inside the sizes array of the current variantSizes object
        updatedVariantSizes[0].sizes[index] = {
            ...updatedVariantSizes[0].sizes[index],
            size: selectedOption ? selectedOption.label : ''  // Set the selected size value
        };

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);
    };

    const calculateTotalStock = () => {
        const total = variantformik.values.variantSizes[0].sizes.reduce((sum, item) => {
            const stockValue = parseInt(item.stock, 10) || 0; // Parse the stock value
            return sum + stockValue;
        }, 0);
        return total;
    };

    const handleSizeStockChange = (index, e) => {
        const { name, value } = e.target;
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Update the size or stock value inside the sizes array of the current variantSizes object
        updatedVariantSizes[0].sizes[index] = {
            ...updatedVariantSizes[0].sizes[index],
            [name]: value // Either 'size' or 'stock'
        };

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);

        // Calculate and update total stock
        const totalStock = calculateTotalStock();
        variantformik.setFieldValue('variantStock', totalStock); // Make sure to manage totalStock in your formik state
    };

    const handleDeleteSizeStock = (index) => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Remove the selected size
        updatedVariantSizes[0].sizes.splice(index, 1);

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);

        // Recalculate total stock after deletion
        const totalStock = calculateTotalStock();
        variantformik.setFieldValue('variantStock', totalStock); // Update total stock in formik state
    };


    const handleSizeCheckboxChange = (sizeLabel, checked) => {
        let newSizes;

        if (checked) {
            newSizes = [...formik.values.sizes, { size: sizeLabel, stock: 0 }];
        } else {
            newSizes = formik.values.sizes.filter(s => s.size !== sizeLabel);
        }

        // Update sizes
        formik.setFieldValue('sizes', newSizes);

        // Update total stock
        const totalStock = newSizes.reduce((sum, s) => sum + (parseInt(s.stock) || 0), 0);
        formik.setFieldValue('stock', totalStock);
    };

    const handleProductSizeStockChangeByName = (sizeLabel, e) => {
        const value = e.target.value;

        const newSizes = formik.values.sizes.map(s =>
            s.size === sizeLabel ? { ...s, stock: value } : s
        );

        // Update sizes
        formik.setFieldValue('sizes', newSizes);

        // Update total stock
        const totalStock = newSizes.reduce((sum, s) => sum + (parseInt(s.stock) || 0), 0);
        formik.setFieldValue('stock', totalStock);
    };




    const handleSpecificationAdd = () => {
        const updatedProductSpecifications = [...formik.values.specs];

        updatedProductSpecifications.push({ name: '' });

        formik.setFieldValue('specs', updatedProductSpecifications);
    };

    const calculateTotalSizeStock = () => {
        return formik.values.sizes.reduce((total, item) => {
            return total + (parseInt(item.stock) || 0); // Convert stock to a number and add it to the total
        }, 0);
    };

    const handleProductSizeStockChange = (index, event) => {
        const { value } = event.target;

        // Update stock for the selected size
        const updatedSizes = [...formik.values.sizes];
        updatedSizes[index].stock = value;

        formik.setFieldValue('sizes', updatedSizes);

        // Calculate the new total size stock and set it in the stock field
        const totalStock = calculateTotalSizeStock();
        formik.setFieldValue('stock', totalStock);
    };


    const handleDeleteProductSizeStock = (index) => {
        // Create a copy of sizes
        const updatedSizes = [...formik.values.sizes];

        // Remove the selected item
        updatedSizes.splice(index, 1);

        // Recalculate total stock
        const totalStock = updatedSizes.reduce((sum, item) => sum + (parseInt(item.stock) || 0), 0);

        // Update Formik state
        formik.setValues({
            ...formik.values,
            sizes: updatedSizes,
            stock: totalStock, // Update total stock
        });
    };

    const handleProductSizeChange = (index, selectedOption) => {
        const updatedSizes = [...formik.values.sizes];
        updatedSizes[index].size = selectedOption ? selectedOption.label : ''; // Update size with selected value
        formik.setFieldValue('sizes', updatedSizes); // Update the sizes array in formik
    };

    const handleProductSpecificationChange = (index, selectedOption) => {
        const updatedSpecifications = [...formik.values.specs];
        updatedSpecifications[index].name = selectedOption ? selectedOption.label : '';
        formik.setFieldValue('specs', updatedSpecifications);
    };


    const handleVariantSpecificationChange = (index, selectedOption) => {
        const updatedVariantSpecifications = [...variantformik.values.specs];
        updatedVariantSpecifications[index].name = selectedOption ? selectedOption.label : ''; // Update size with selected value
        variantformik.setFieldValue('specs', updatedVariantSpecifications); // Update the sizes array in formik
    };

    const getS3KeyFromUrl = (url) => {
        if (!url) return '';

        try {
            // Handle already being an S3 key (no http://)
            if (!url.startsWith('http')) {
                return url; // Already an S3 key
            }

            // Extract the path before query parameters
            const urlWithoutParams = url.split('?')[0];

            // Extract the path after the domain
            const urlObj = new URL(urlWithoutParams);
            const pathname = urlObj.pathname;

            // Remove leading slash and decode URL encoding
            const decodedPath = decodeURIComponent(pathname.substring(1));

            return decodedPath;
        } catch (error) {
            console.error('Error parsing URL:', error);
            return '';
        }
    };



    // Client-side filter helper: matches option.label (case-insensitive substring)
    const filterOptions = (list, inputValue) => {
        const q = (inputValue || '').toLowerCase().trim();
        if (!q) return list || [];
        return (list || []).filter(item => (item?.label || '').toLowerCase().includes(q));
    };

    // Fill With AI — only wired on the create page (id === undefined)
    const [aiFilling, setAiFilling] = useState(false);
    const [aiErrorModal, setAiErrorModal] = useState({ show: false, message: '', code: '', confidence: '' });
    const canFillWithAi = !id && (formik.values.images?.length || 0) > 0 && !aiFilling;

    const dataUrlToBlob = (dataUrl) => {
        if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) return null;
        const [meta, base64] = dataUrl.split(',');
        const mime = (meta.match(/data:(.*?);/) || [])[1] || 'image/jpeg';
        try {
            const bin = atob(base64);
            const bytes = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
            return new Blob([bytes], { type: mime });
        } catch (e) {
            return null;
        }
    };

    const handleFillWithAi = async () => {
        if (!canFillWithAi) return;
        setAiFilling(true);
        try {
            const fd = new FormData();
            (formik.values.images || []).forEach((dataUrl, i) => {
                const blob = dataUrlToBlob(dataUrl);
                if (!blob) return;
                const ext = (blob.type.split('/')[1] || 'jpg').split('+')[0];
                fd.append('images', blob, `product_${i + 1}.${ext}`);
            });
            const catName = formik.values?.selectedCategory?.label;
            const subCatName = formik.values?.selectedSubCategory?.label;
            if (catName) fd.append('categoryName', catName);
            if (subCatName) fd.append('subCategoryName', subCatName);

            const response = await aiFillerProduct(fd);
            const payload = response?.data?.data;
            if (response?.data?.success && payload) {
                const patch = {};
                if (payload.productName) patch.productName = payload.productName;
                if (payload.description) patch.description = payload.description;
                if (payload.color) patch.color = payload.color;
                // Price and discounted price are NOT auto-filled — the "AI suggests" hint next
                // to each field lets the vendor accept the estimate with a single click.
                // Category (UI "Category" dropdown is stored under subCategoryId / selectedCategory)
                if (payload.subCategoryId != null && payload.subCategoryName) {
                    patch.subCategoryId = payload.subCategoryId;
                    patch.selectedCategory = { value: payload.subCategoryId, label: payload.subCategoryName };
                }
                // Sub-category (UI "Sub-Category" is stored under subSubCategoryId / selectedSubCategory)
                if (payload.subSubCategoryId != null && payload.subSubCategoryName) {
                    patch.subSubCategoryId = payload.subSubCategoryId;
                    patch.selectedSubCategory = { value: payload.subSubCategoryId, label: payload.subSubCategoryName };
                }
                if (Object.keys(patch).length > 0) {
                    formik.setValues((prev) => ({ ...prev, ...patch }));
                }
                // CKEditor's `data` prop is initialize-only; push the new description into the live editor instance.
                if (payload.description && descriptionEditorRef.current) {
                    try { descriptionEditorRef.current.setData(payload.description); } catch (_) { /* editor not ready */ }
                }
                if (payload.aiEstimatedPrice != null) setAiEstimatedPrice(payload.aiEstimatedPrice);
                if (payload.aiEstimatedDiscountedPrice != null) setAiEstimatedDiscountedPrice(payload.aiEstimatedDiscountedPrice);
                if (payload.color) setSelectedColor(payload.color);
                toast.success(response?.data?.message || 'Product details filled by AI');
            } else {
                const body = response?.data || {};
                setAiErrorModal({
                    show: true,
                    message: body.rejectionReason || body.message || 'AI could not generate details for this image',
                    code: body.code || '',
                    confidence: body.garmentConfidence || '',
                });
            }
        } catch (err) {
            const body = err?.response?.data || {};
            setAiErrorModal({
                show: true,
                message: body.rejectionReason || body.message || 'Failed to fill details with AI',
                code: body.code || '',
                confidence: body.garmentConfidence || '',
            });
        } finally {
            setAiFilling(false);
        }
    };

    const closeAiErrorModal = () => setAiErrorModal({ show: false, message: '', code: '', confidence: '' });

    const loadOptionsCategory = (inputValue) =>
        Promise.resolve(filterOptions(category, inputValue));

    const loadOptionsBrands = (inputValue) =>
        Promise.resolve(filterOptions(brands, inputValue));

    const loadOptionsManufacture = (inputValue) =>
        Promise.resolve(filterOptions(manufacturers, inputValue));

    // Kept as no-ops so existing AsyncSelect props keep working; pagination is disabled now.
    const handleMenuScrollToBottom = () => { };
    const handleMenuScrollToBottomManufacture = () => { };

    // Load full brand list (up to 1000) once per vendor change
    useEffect(() => {
        getBrandListing({ vendorId: user?.vendorId ?? formik?.values?.manufacturerId, page: 1, pageSize: 1000, search: '' })(response => {
            if (response?.statusCode == 200) {
                const mapped = (response?.data || []).map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                setBrands(mapped);

                // Auto-select the brand if the vendor has exactly one — for admin (after picking a vendor)
                // and for vendor users (only their own brands are returned).
                if (mapped.length === 1 && !formik.values.brandId) {
                    const only = mapped[0];
                    formik.setValues((prev) => ({
                        ...prev,
                        brandId: only.value,
                        selectedBrand: only,
                    }));
                }
            }
        })
    }, [manufacturers, formik.values.manufacturerId])

    const onBrandChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            brandId: selectedOption ? selectedOption.value : '',
            selectedBrand: selectedOption,
        });
    };


    const onManufactureChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            manufacturerId: selectedOption ? selectedOption.value : '',
            selectedManufacture: selectedOption,
            selectedBrand: '',
            brandId: '',
        });
    };

    const onCategoryChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            subCategoryId: selectedOption ? selectedOption.value : '',
            selectedCategory: selectedOption,
            subSubCategoryId: '',           // Reset subcategory
            selectedSubCategory: '',        // Reset subcategory select
            sizes: [], // Reset sizes to initial state
            stock: '',                      // Optionally reset stock as well
            specs: [],                      // Reset specs — parameters vary per sub-sub-category
        });
        setSubCategory([]); // Optionally clear subcategory options
        setSubSubCategory([]); // Optionally clear sizes options
        setSpecificationDrpDwn([]); // Clear parameter list until the next fetch
    };

    const onSubCategoryChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            subSubCategoryId: selectedOption ? selectedOption.value : '',
            selectedSubCategory: selectedOption,
            // Reset sizes + total stock — the subSubCategoryId useEffect will pre-check
            // every fetched size with stock: 0 for the new sub-category.
            sizes: [],
            stock: '',
            // Reset specs — the parameter list belongs to the previous sub-sub-category and
            // may not match the new one (which could even have no parameters at all).
            specs: [],
        });
        setSpecificationDrpDwn([]); // Clear parameter list until the next fetch resolves
    };

    let parentTimer;
    const loadSizesData = (inputValue) => {
        return new Promise((resolve, reject) => {
            clearTimeout(parentTimer);
            parentTimer = setTimeout(() => {
                if (inputValue.length >= 2) {

                    getSubCategoryDetails({ page: 1, limit: 10, search: inputValue })((response) => {
                        if (response && response.status) {
                            setSubSubCategory(response?.data?.data?.SubSubcategorySizes?.map((item, index) => {
                                return {
                                    value: item.id,
                                    label: item.size
                                }

                            }));
                            resolve(response?.data?.data?.SubSubcategorySizes?.map((item, index) => {
                                return {
                                    value: item.id,
                                    label: item.size
                                }

                            }));
                        }
                    });
                }
                else {
                    resolve([]);
                    setSubSubCategory([])
                }

            }, 500);
        });
    }

    const onSizesChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            size: selectedOption ? selectedOption.value : '',
            selectedSize: selectedOption,
        });
    };



    const getStoresDetails = () => {
        getStoresListing()((response) => {
            if (response?.statusCode === 200) {
                setStore(response?.data?.[0]);
                if (user?.userType === "Vendor") {
                    formik.setFieldValue('manufacturerId', response?.data?.[0]?.id)
                }
            } else {

            }
        });
    };


    const getProducts = async () => {
        setFetching(true);
        getProductsDetails(id)(async (response) => {
            if (response?.data?.statusCode == 200) {
                const product = response?.data?.data?.product
                const selectedTagIds = product?.productTags?.map(tag => tag.tagId) || [];

                formik.setValues((prevState) =>
                ({

                    ...prevState,
                    productId: id,
                    thumbnailImageUrl: product?.thumbnailImageUrl || '',
                    productName: product?.productName ? product?.productName : '',
                    description: product?.description ? product?.description : '',
                    selectedCategory: {
                        value: product?.productSubcategory?.id ? product?.productSubcategory?.id : '',
                        label: product?.productSubcategory?.title ? product?.productSubcategory?.title : ''
                    },
                    selectedSubCategory: {
                        value: product?.productSubsubcategory?.id ? product?.productSubsubcategory?.id : '',
                        label: product?.productSubsubcategory?.title ? product?.productSubsubcategory?.title : ''
                    },
                    selectedManufacture: {
                        value: product?.manufacturer?.id ? product?.manufacturer?.id : '',
                        label: product?.manufacturer?.storeName ? product?.manufacturer?.storeName : ''
                    },
                    brandId: product?.brandId,
                    selectedBrand: {
                        value: product?.brand?.id ? product?.brand?.id : '',
                        label: product?.brand?.name ? product?.brand?.name : ''
                    },
                    subCategoryId: product?.productSubcategory?.id ? product?.productSubcategory?.id : '',
                    subSubCategoryId: product?.productSubsubcategory?.id ? product?.productSubsubcategory?.id : '',
                    manufacturerId: product?.manufacturer?.id ? product?.manufacturer?.id : '',
                    price: product?.price ? product?.price : '',
                    discountedPrice: product?.discountedPrice ? product?.discountedPrice : '',
                    images: [],
                    fabricType: product?.fabricType ? product?.fabricType : '',
                    sleeveType: product?.sleeveType ? product?.sleeveType : '',
                    fitType: product?.fitType ? product?.fitType : '',
                    neckType: product?.neckType ? product?.neckType : '',
                    color: product?.color ? product?.color : '',
                    stock: product?.stock ? product?.stock : '',
                    xtraSmall: product?.xtraSmall ? product?.xtraSmall : '',
                    small: product?.small ? product?.small : '',
                    medium: product?.medium ? product?.medium : '',
                    large: product?.large ? product?.large : '',
                    xtraLarge: product?.xtraLarge ? product?.xtraLarge : '',
                    specs: product?.specifications ? product?.specifications : [],
                    sizes: product?.productParameters?.length > 0 ? product?.productParameters?.[0]?.variation_sizes || [] : [],
                    variants: product?.variants ? product?.variants : [],
                    isActive: true,
                    tags: selectedTagIds,
                }))


                setOldImages(product?.images)
                setOldVariantImages([])
                setIsAiGenerated(!!product?.isAiGenerated)
                setAiEstimatedPrice(product?.aiEstimatedPrice ?? null)
                setAiEstimatedDiscountedPrice(product?.aiEstimatedDiscountedPrice ?? null)
                setIsPublished(!!product?.isPublished)
                setFetching(false)
            } else {
                setFetching(false)
            }
        })
    }



    const handleDeleteImage = (index, isOldImage = false) => {
        const totalImages =
            (oldImages?.length || 0) + (formik.values.images?.length || 0);
        if (totalImages <= 1) {
            toast.error(
                "At least one product image is required. Add another image before removing this one."
            );
            return;
        }

        // If the image is from oldImages (already uploaded)
        if (isOldImage && oldImages && oldImages[index]) {
            const imageId = oldImages[index].id; // or use imageUrl/S3 key if your API expects that
            deleteProductImage(imageId)((response) => {
                if (response?.statusCode === 200) {
                    // Remove from UI state after successful deletion
                    const newOldImages = [...oldImages];
                    newOldImages.splice(index, 1);
                    setOldImages(newOldImages);
                    toast.success("Image deleted successfully");
                } else {
                    toast.error("Failed to delete image");
                }
            });
        } else {
            // For new images (not yet uploaded), just remove from Formik state
            const newFormikImages = [...formik.values.images];
            newFormikImages.splice(index, 1);
            formik.setFieldValue('images', newFormikImages);
        }
    };

    const [images, setImages] = useState(variantformik.values.variantImages || []);

    // Sync the local state with formik values whenever formik values change
    useEffect(() => {
        setImages(variantformik.values.variantImages || []);
    }, [variantformik.values.variantImages]);


    const handleDeleteVariantImage = (index) => {
        // Filter out the image to be deleted by its index
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
        variantformik.setFieldValue('variantImages', updatedImages); // Update formik state
    };


    const deleteImage = (index) => {
        const updatedImages = [...oldVariantImages];
        updatedImages.splice(index, 1);
        setOldVariantImages(updatedImages);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleClickOutside = event => {
        if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
            setColorPickerVisible(false);
        }
    };

    const handleColorChange = (color) => {
        formik.setFieldValue('color', color.hex);
        setSelectedColor(color.hex);
    };
    const handleColorVaiantChange = (color) => {
        variantformik.setFieldValue('variantColor', color.hex);
        setSelectedColorVariant(color.hex);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
        variantformik.setFieldValue(name, trimmedValue);
    };


    useEffect(() => {
        if (formik?.values?.subCategoryId) {
            getSubCategoryListingPaginate({ page: 1, limit: 1000, search: '', categoryIds: [formik?.values?.subCategoryId] })(response => {
                if (response?.statusCode == 200) {
                    setSubCategory(response?.results)
                } else {
                    setSubCategory([])
                }
            })


        }
    }, [formik?.values?.subCategoryId]);

    useEffect(() => {
        if (formik?.values?.subSubCategoryId) {
            getSubCategoryDetails(formik?.values?.subSubCategoryId)(response => {
                if (response?.data?.statusCode == 200) {
                    const fetchedSizes = (response?.data?.data?.SubSubcategorySizes || []).map((item) => ({
                        value: item.id,
                        label: item.size,
                    }));
                    setSubSubCategory(fetchedSizes);
                    setSpecificationDrpDwn(response?.data?.data?.SubSubcategoryParameters?.map((item, index) => {
                        return {
                            value: item.id,
                            label: item.parameter
                        }
                    }))

                    // ✅ Add this to set tags from API response
                    setTags(response?.data?.data?.tags || []);

                    // Pre-check every fetched size by default — only when the user hasn't already
                    // selected sizes (protects edit-mode where existing sizes are loaded first).
                    if (fetchedSizes.length > 0) {
                        formik.setValues((prev) => {
                            if ((prev?.sizes || []).length > 0) return prev;
                            return {
                                ...prev,
                                sizes: fetchedSizes.map((s) => ({ size: s.label, stock: 0 })),
                            };
                        });
                    }
                } else {
                    setTags([]); // Reset tags if no data
                }
            })
        } else {
            setTags([]); // Reset tags when no subcategory selected
        }
    }, [formik?.values?.subSubCategoryId]);

    useEffect(() => {

        getStoresDetails()
        getCategoryListingPaginate({ page: 1, limit: 1000, search: '' })(response => {
            if (response?.statusCode == 200) {
                setCategory(response?.results)
            } else {
                setCategory([])
            }
        })

        getManufacturesListingPaginate({ page: 1, limit: 1000, search: '' })(response => {
            if (response?.statusCode == 200) {
                setManufacturers(response?.results)
            } else {
            }
        })

    }, []);



    useEffect(() => {
        if (id) {
            setFetching(true)
            getProducts()
        }
    }, [update, id])

    useEffect(() => {
        if (formik.submitCount === 0 || formik.isSubmitting || formik.isValid) return;
        const errors = formik.errors || {};
        const fieldOrder = [
            'selectedManufacture',
            'selectedBrand',
            'productName',
            'price',
            'discountedPrice',
            'color',
            'selectedCategory',
            'selectedSubCategory',
            'fabricType',
            'sleeveType',
            'fitType',
            'neckType',
            'description',
            'images',
            'sizes',
            'stock',
        ];
        const firstErrorKey = fieldOrder.find((k) => errors[k]) || Object.keys(errors)[0];
        if (!firstErrorKey) return;
        const el =
            document.querySelector(`[name="${firstErrorKey}"]`) ||
            document.getElementById(`field-${firstErrorKey}`) ||
            document.querySelector(`[data-field="${firstErrorKey}"]`);
        if (el && typeof el.scrollIntoView === 'function') {
            const target = el.closest?.('.mb-4, .form-group') || el;
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (typeof el.focus === 'function') {
                setTimeout(() => el.focus({ preventScroll: true }), 400);
            }
        }
    }, [formik.submitCount, formik.isSubmitting]);

    const handleSpecificSubmit = () => {
        // Use Formik's setFieldValue to add the specification to the specs array
        const newSpec = { name: specificChange, value: "" };  // Example for a single name/value pair
        formik.setFieldValue('specs', [...formik.values.specs, newSpec]);

        // Close the modal
        setShowSpecification(false);
    };

    const handleVairantSpecificSubmit = () => {
        // Use Formik's setFieldValue to add the specification to the specs array
        const newSpec = { name: variantspecificChange, value: "" };  // Example for a single name/value pair
        variantformik.setFieldValue('specs', [...variantformik.values.specs, newSpec]);

        // Close the modal
        setShowVariantSpecification(false);
        setShow(true);
    };

    const handleDeleteSpecific = (indexToDelete) => {
        const updatedSpecs = formik.values.specs.filter((_, index) => index !== indexToDelete);
        formik.setFieldValue('specs', updatedSpecs);
    };

    const handleVariantDeleteSpecific = (indexToDelete) => {
        const updatedSpecs = variantformik.values.specs.filter((_, index) => index !== indexToDelete);
        variantformik.setFieldValue('specs', updatedSpecs);
    };

    const customNoOptionsMessage = ({ inputValue }) => {
        return inputValue.length < 2
            ? "Please type atleast 2 characters"
            : "No options";
    };

    const handleDeleteVariant = (indexToDelete) => {
        const updatedVariants = formik.values.variants.filter((_, index) => index !== indexToDelete);
        formik.setFieldValue('variants', updatedVariants); // Update formik state with the new variants array
    };


    const handleTagSelection = (tagId) => {
        const currentSelectedTags = [...formik.values.tags];
        const isSelected = currentSelectedTags.includes(tagId);

        if (isSelected) {
            // Remove tag if already selected
            const updatedTags = currentSelectedTags.filter(id => id !== tagId);
            formik.setFieldValue('tags', updatedTags);
        } else {
            // Add tag if not selected
            const updatedTags = [...currentSelectedTags, tagId];
            formik.setFieldValue('tags', updatedTags);
        }
    };

    // Helper function to check if a tag is selected
    const isTagSelected = (tagId) => {
        return formik.values.tags.includes(tagId);
    };


    return (
        <>

            {fetching ? (

                <Loader />

            ) : (
                <div className="edit-inventory-page">
                    <style>{`
                        /* Compact sticky header padding — matches Tracking / homepage */
                        .edit-inventory-page .create-inventory-sticky-header {
                            padding: clamp(12px, 1.4vw, 20px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 16px) !important;
                            margin: -20px -24px 16px !important;
                            border-bottom: 1px solid #eef2f7 !important;
                            box-shadow: none !important;
                        }
                        @media (max-width: 991px) {
                            .edit-inventory-page .create-inventory-sticky-header {
                                padding: 12px 20px 10px !important;
                                margin: -20px -20px 12px !important;
                            }
                        }
                        @media (max-width: 575px) {
                            .edit-inventory-page .create-inventory-sticky-header {
                                padding: 10px 16px 8px !important;
                                margin: -20px -12px 10px !important;
                            }
                        }
                        /* Page title matches homepage greeting */
                        .edit-inventory-page .create-inventory-sticky-header h4 { font-size: 18px !important; font-weight: 700 !important; color: #0f172a !important; letter-spacing: -0.01em !important; }
                        /* Everything else stays compact */
                        /* Thumbnail frame — grows to match the left Product Details height on desktop, fixed on mobile */
                        .edit-inventory-page .product-thumbnail-frame {
                            width: 100%;
                            flex: 1 1 auto;
                            min-height: 320px;
                            overflow: hidden;
                            border-radius: 12px;
                            border: 1px solid #dee2e6;
                            background: #f8fafc;
                            position: relative;
                        }
                        @media (max-width: 767.98px) {
                            .edit-inventory-page .product-thumbnail-frame {
                                flex: 0 0 auto;
                                height: 320px;
                                min-height: 320px;
                            }
                        }

                        /* Product images card body — drag & drop container */
                        .edit-inventory-page .product-images-body { position: relative; transition: background 0.15s ease; }
                        .edit-inventory-page .product-images-body.is-dragging { background: rgba(0, 134, 149, 0.04); }
                        .edit-inventory-page .product-images-body.is-dragging::before {
                            content: '';
                            position: absolute;
                            inset: 6px;
                            border: 2px dashed #008695;
                            border-radius: 10px;
                            pointer-events: none;
                            z-index: 5;
                        }
                        /* Empty-state dropzone for Product Images card */
                        .edit-inventory-page .product-images-dropzone {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            gap: 10px;
                            width: 100%;
                            min-height: 380px;
                            padding: 24px;
                            border-radius: 12px;
                            border: 2px dashed #cbd5e1;
                            background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
                            color: #64748b;
                            cursor: pointer;
                            text-align: center;
                            transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, transform 0.15s ease;
                            margin: 0;
                        }
                        .edit-inventory-page .product-images-dropzone:hover,
                        .edit-inventory-page .product-images-body.is-dragging .product-images-dropzone {
                            border-color: #008695;
                            background: linear-gradient(180deg, #f0fdfa 0%, #ecfdf5 100%);
                            color: #0f766e;
                        }
                        .edit-inventory-page .product-images-dropzone:active { transform: scale(0.995); }
                        .edit-inventory-page .product-images-dropzone-icon {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            background: #fff;
                            border: 1px solid #e2e8f0;
                            color: #008695;
                            font-size: 26px;
                            box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
                        }
                        .edit-inventory-page .product-images-dropzone-title {
                            font-size: 14px;
                            font-weight: 600;
                            color: #0f172a;
                            letter-spacing: -0.01em;
                        }
                        .edit-inventory-page .product-images-dropzone-hint {
                            font-size: 11px;
                            color: #94a3b8;
                            font-weight: 500;
                        }

                        /* Fill with AI button — sparkle animation, gradient background */
                        .edit-inventory-page .ai-fill-btn {
                            position: relative;
                            display: inline-flex;
                            align-items: center;
                            gap: 7px;
                            padding: 6px 14px;
                            height: 30px;
                            border: 0;
                            border-radius: 999px;
                            background: linear-gradient(135deg, #7c3aed 0%, #ec4899 50%, #f59e0b 100%);
                            background-size: 200% 200%;
                            color: #fff;
                            font-family: 'Sora', 'Inter', ui-sans-serif, system-ui, sans-serif;
                            font-size: 10px;
                            font-weight: 500;
                            font-style: italic;
                            letter-spacing: 0.01em;
                            text-transform: none;
                            cursor: pointer;
                            box-shadow: none;
                            overflow: visible;
                            animation: ai-fill-shimmer 6s ease-in-out infinite;
                            transition: transform 0.15s ease, opacity 0.15s ease;
                            white-space: nowrap;
                        }
                        .edit-inventory-page .ai-fill-btn:not(:disabled):hover {
                            transform: translateY(-1px);
                        }
                        .edit-inventory-page .ai-fill-btn:disabled {
                            cursor: not-allowed;
                            animation: none;
                            background: linear-gradient(135deg, #f5f3ff 0%, #fdf2f8 50%, #fffbeb 100%);
                            color: #a78bfa;
                            box-shadow: inset 0 0 0 1px #ede9fe;
                        }
                        .edit-inventory-page .ai-fill-btn:disabled .ai-fill-icon {
                            color: #c4b5fd !important;
                            animation: ai-fill-wand-idle 3.2s ease-in-out infinite;
                        }
                        .edit-inventory-page .ai-fill-btn:disabled .ai-fill-label { color: #a78bfa !important; }
                        @keyframes ai-fill-wand-idle {
                            0%, 100% { transform: rotate(0deg); opacity: 0.85; }
                            50%      { transform: rotate(-8deg); opacity: 1; }
                        }
                        .edit-inventory-page .ai-fill-btn .ai-fill-icon {
                            display: inline-flex !important;
                            align-items: center;
                            font-size: 11px !important;
                            font-weight: 700 !important;
                            color: #fff !important;
                            animation: ai-fill-wand 2.4s ease-in-out infinite;
                            transform-origin: 60% 60%;
                        }
                        .edit-inventory-page .ai-fill-btn .ai-fill-icon svg { color: inherit !important; fill: currentColor !important; }
                        .edit-inventory-page .ai-fill-btn .ai-fill-label {
                            color: #fff !important;
                            font-family: 'Sora', 'Inter', ui-sans-serif, system-ui, sans-serif !important;
                            font-size: 10px !important;
                            font-weight: 500 !important;
                            font-style: italic !important;
                            line-height: 1 !important;
                            letter-spacing: 0.01em !important;
                            text-transform: none !important;
                        }
                        .edit-inventory-page .ai-fill-btn:disabled .ai-fill-icon { animation: none; }
                        .edit-inventory-page .ai-fill-btn.is-loading .ai-fill-icon { animation: ai-fill-wand-loading 1s linear infinite; }
                        .edit-inventory-page .ai-fill-btn .ai-fill-sparkles {
                            position: absolute;
                            inset: 0;
                            pointer-events: none;
                            overflow: visible;
                        }
                        .edit-inventory-page .ai-fill-btn .ai-fill-spark {
                            position: absolute;
                            width: 4px;
                            height: 4px;
                            border-radius: 50%;
                            background: #fff;
                            box-shadow: 0 0 6px 1px rgba(255,255,255,0.9);
                            opacity: 0;
                        }
                        .edit-inventory-page .ai-fill-btn .ai-fill-spark-1 { top: -3px; left: 18%; animation: ai-fill-spark 2.6s ease-in-out infinite; }
                        .edit-inventory-page .ai-fill-btn .ai-fill-spark-2 { bottom: -3px; right: 30%; animation: ai-fill-spark 2.6s ease-in-out infinite 0.85s; }
                        .edit-inventory-page .ai-fill-btn .ai-fill-spark-3 { top: 40%; right: -3px; animation: ai-fill-spark 2.6s ease-in-out infinite 1.6s; }
                        .edit-inventory-page .ai-fill-btn:disabled .ai-fill-spark { animation: none; }
                        @keyframes ai-fill-shimmer {
                            0%, 100% { background-position: 0% 50%; }
                            50%      { background-position: 100% 50%; }
                        }
                        @keyframes ai-fill-wand {
                            0%, 40%, 100% { transform: rotate(0deg); }
                            10%           { transform: rotate(-14deg); }
                            22%           { transform: rotate(10deg); }
                            32%           { transform: rotate(-4deg); }
                        }
                        @keyframes ai-fill-wand-loading {
                            from { transform: rotate(0deg); }
                            to   { transform: rotate(360deg); }
                        }
                        @keyframes ai-fill-spark {
                            0%, 100% { opacity: 0; transform: scale(0.4); }
                            30%      { opacity: 1; transform: scale(1); }
                            60%      { opacity: 0; transform: scale(0.4); }
                        }
                        @media (max-width: 575px) {
                            .edit-inventory-page .ai-fill-btn { padding: 5px 10px; height: 26px; gap: 5px; }
                            .edit-inventory-page .ai-fill-btn .ai-fill-label { display: inline-block; font-size: 9px !important; }
                            .edit-inventory-page .ai-fill-btn .ai-fill-icon { font-size: 10px !important; }
                        }
                        @media (prefers-reduced-motion: reduce) {
                            .edit-inventory-page .ai-fill-btn,
                            .edit-inventory-page .ai-fill-btn .ai-fill-icon,
                            .edit-inventory-page .ai-fill-btn .ai-fill-spark { animation: none !important; }
                        }

                        .edit-inventory-page h3 { font-size: 14px !important; }
                        .edit-inventory-page h4 { font-size: 13px !important; }
                        .edit-inventory-page h5 { font-size: 11px !important; }
                        .edit-inventory-page h6 { font-size: 10px !important; }
                        .edit-inventory-page p { font-size: 10px; }
                        .edit-inventory-page .small, .edit-inventory-page small { font-size: 9px !important; }
                        .edit-inventory-page .badge { font-size: 8px !important; padding: 2px 5px !important; }

                        /* Cards */
                        .edit-inventory-page .card {
                            border-radius: 6px !important;
                            border: 1px solid #e2e8f0 !important;
                            margin-bottom: 8px !important;
                            box-shadow: 0 1px 2px rgba(15,23,42,0.03) !important;
                        }
                        .edit-inventory-page .card.mb-4 { margin-bottom: 8px !important; }
                        .edit-inventory-page .card-header {
                            background: #f8fafc !important;
                            border-bottom: 1px solid #e2e8f0 !important;
                            padding: 8px 12px !important;
                            min-height: unset !important;
                        }
                        /* Card header text — 12px semibold across all sections */
                        .edit-inventory-page .card-header span,
                        .edit-inventory-page .card-header h1,
                        .edit-inventory-page .card-header h2,
                        .edit-inventory-page .card-header h3,
                        .edit-inventory-page .card-header h4,
                        .edit-inventory-page .card-header h5,
                        .edit-inventory-page .card-header h6 {
                            font-size: 12px !important;
                            font-weight: 600 !important;
                            color: #0f172a !important;
                            letter-spacing: normal !important;
                            margin: 0 !important;
                        }
                        /* Muted / error helpers inside card headers */
                        .edit-inventory-page .card-header span[style*="dc2626"],
                        .edit-inventory-page .card-header span[style*="red"] {
                            font-size: 10px !important;
                            font-weight: 500 !important;
                            color: #dc2626 !important;
                        }
                        .edit-inventory-page .card-header span[style*="6c757d"] {
                            font-size: 10px !important;
                            font-weight: 400 !important;
                            color: #64748b !important;
                        }
                        /* Card body — override all padding utility variants */
                        .edit-inventory-page .card-body { padding: 10px !important; }
                        .edit-inventory-page .card-body.p-2 { padding: 8px !important; }
                        .edit-inventory-page .card-body.p-3 { padding: 10px !important; }
                        .edit-inventory-page .card-body.p-4 { padding: 12px !important; }
                        .edit-inventory-page .card-body.p-5 { padding: 12px !important; }
                        .edit-inventory-page .card-body[class*="px-4"] { padding-left: 12px !important; padding-right: 12px !important; }
                        .edit-inventory-page .card-body[class*="py-5"] { padding-top: 12px !important; padding-bottom: 12px !important; }
                        .edit-inventory-page .card-body[class*="py-4"] { padding-top: 12px !important; padding-bottom: 12px !important; }

                        /* Form labels */
                        .edit-inventory-page .form-label { font-size: 9px !important; font-weight: 600 !important; color: #475569 !important; margin-bottom: 3px !important; text-transform: uppercase; letter-spacing: 0.04em; }

                        /* Form controls */
                        .edit-inventory-page .form-control,
                        .edit-inventory-page .form-select,
                        .edit-inventory-page .rounded-input {
                            border-radius: 4px !important;
                            padding: 4px 8px !important;
                            font-size: 10px !important;
                            border: 1px solid #e2e8f0 !important;
                            color: #0f172a !important;
                            min-height: 28px !important;
                            line-height: 1.4 !important;
                        }
                        .edit-inventory-page .form-control:focus,
                        .edit-inventory-page .form-select:focus {
                            border-color: #008695 !important;
                            box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                        }
                        .edit-inventory-page textarea.form-control { min-height: 52px !important; }
                        .edit-inventory-page .form-control::placeholder { color: #94a3b8 !important; font-size: 10px !important; }

                        /* Form spacing — tighter vertical rhythm between fields */
                        .edit-inventory-page .form-group.mb-4,
                        .edit-inventory-page .mb-4 { margin-bottom: 4px !important; }
                        .edit-inventory-page .form-group.mb-3,
                        .edit-inventory-page .mb-3 { margin-bottom: 3px !important; }
                        .edit-inventory-page .form-group.mb-2,
                        .edit-inventory-page .mb-2 { margin-bottom: 2px !important; }
                        .edit-inventory-page .card-body .row > [class*="col-"] > .form-group { margin-bottom: 4px !important; }
                        .edit-inventory-page .card-body .row { row-gap: 2px !important; }

                        /* Buttons (form) */
                        .edit-inventory-page .btn { font-size: 10px !important; border-radius: 4px !important; padding: 4px 10px !important; }
                        /* Header submit button — matches homepage refresh/action button */
                        .edit-inventory-page .create-inventory-sticky-header .request_btn {
                            background: #008695 !important;
                            border: 1px solid #008695 !important;
                            color: #fff !important;
                            font-weight: 600 !important;
                            padding: 6px 16px !important;
                            border-radius: 4px !important;
                            font-size: 12px !important;
                            height: 34px !important;
                            display: inline-flex !important;
                            align-items: center !important;
                            gap: 6px !important;
                            white-space: nowrap;
                            transition: all 0.15s ease;
                        }
                        .edit-inventory-page .create-inventory-sticky-header .request_btn:hover {
                            background: #006672 !important;
                            border-color: #006672 !important;
                            color: #fff !important;
                        }
                        /* Fallback for any other .request_btn used in form content */
                        .edit-inventory-page .request_btn {
                            background: #008695 !important;
                            border-color: #008695 !important;
                            color: #fff !important;
                            font-weight: 600 !important;
                            padding: 6px 14px !important;
                            border-radius: 4px !important;
                            font-size: 12px !important;
                            height: 34px;
                            display: inline-flex;
                            align-items: center;
                            gap: 6px;
                        }

                        /* Pills */
                        .edit-inventory-page .draft-pill {
                            font-size: 8px !important;
                            padding: 2px 6px !important;
                            border-radius: 3px !important;
                            background: #fef3c7 !important;
                            color: #92400e !important;
                            border: 1px solid #fde68a !important;
                            font-weight: 600;
                            letter-spacing: 0.03em;
                        }
                        .edit-inventory-page .ai-pill {
                            font-size: 8px !important;
                            padding: 2px 6px !important;
                            border-radius: 3px !important;
                            background: linear-gradient(135deg, #ede9fe, #fce7f3) !important;
                            color: #6d28d9 !important;
                            border: 1px solid #ddd6fe !important;
                            font-weight: 600;
                            display: inline-flex;
                            align-items: center;
                            gap: 3px;
                            letter-spacing: 0.03em;
                        }

                        /* React-select overrides */
                        .edit-inventory-page .select__control {
                            min-height: 28px !important;
                            border-radius: 4px !important;
                            border: 1px solid #e2e8f0 !important;
                            font-size: 10px !important;
                        }
                        .edit-inventory-page .select__control--is-focused {
                            border-color: #008695 !important;
                            box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                        }
                        .edit-inventory-page .select__value-container { padding: 1px 6px !important; }
                        .edit-inventory-page .select__placeholder { color: #94a3b8 !important; font-size: 10px !important; }
                        .edit-inventory-page .select__single-value { font-size: 10px !important; }
                        .edit-inventory-page .select__multi-value { background: #eff6ff !important; border-radius: 3px !important; }
                        .edit-inventory-page .select__multi-value__label { font-size: 9px !important; padding: 1px 4px !important; color: #1d4ed8 !important; }
                        .edit-inventory-page .select__option { font-size: 10px !important; padding: 4px 8px !important; }
                        .edit-inventory-page .select__indicator { padding: 4px !important; }
                        .edit-inventory-page .select__indicator svg { width: 14px; height: 14px; }

                        /* Feedback / invalid text */
                        .edit-inventory-page .invalid-feedback { font-size: 9px !important; margin-top: 2px !important; }
                        .edit-inventory-page .invalid-feedbacks { font-size: 9px !important; margin-top: 2px !important; }
                        .edit-inventory-page .custom-required { font-size: 9px !important; margin-top: 2px !important; }

                        /* Empty state / placeholder text inside cards */
                        .edit-inventory-page .card-body .text-muted { font-size: 10px !important; }
                        .edit-inventory-page .card-body p.text-muted { font-size: 10px !important; }

                        /* Table (variants, etc.) */
                        .edit-inventory-page .table { font-size: 9px !important; }
                        .edit-inventory-page .table th { font-size: 8px !important; padding: 6px !important; color: #475569; text-transform: uppercase; letter-spacing: 0.04em; }
                        .edit-inventory-page .table td { padding: 6px !important; vertical-align: middle; font-size: 9px !important; }

                        /* Sticky header — use shared clamp() padding from custom.scss (matches homepage) */

                        /* AI recommended price — compact clickable pill (whole thing clickable) */
                        .edit-inventory-page button.ai-price-hint,
                        .edit-inventory-page .ai-price-hint {
                            display: inline-flex !important;
                            align-items: center !important;
                            gap: 4px !important;
                            margin-top: 6px !important;
                            padding: 3px 10px !important;
                            border-radius: 999px !important;
                            background: #f0fdfa !important;
                            border: 1px solid #99f6e4 !important;
                            line-height: 1.4 !important;
                            cursor: pointer !important;
                            appearance: none !important;
                            -webkit-appearance: none !important;
                            box-shadow: none !important;
                            outline: none !important;
                            font-family: inherit !important;
                            transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
                        }
                        .edit-inventory-page .ai-price-hint:hover {
                            background: #ccfbf1 !important;
                            border-color: #5eead4 !important;
                        }
                        .edit-inventory-page .ai-price-hint:active {
                            transform: scale(0.98);
                        }
                        .edit-inventory-page .ai-price-hint:focus {
                            outline: none !important;
                            box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                        }
                        .edit-inventory-page .ai-price-hint::before {
                            content: "";
                            width: 10px;
                            height: 10px;
                            display: inline-block;
                            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23008695'><path d='M12 2l1.9 4.8L18.5 8.5 14 11l-1 5.2L9 13l-4.5 2.2L6 10.5 2 8.5l4.6-1.7z'/></svg>") !important;
                            background-size: contain !important;
                            background-repeat: no-repeat !important;
                            flex-shrink: 0;
                        }
                        .edit-inventory-page .ai-price-hint-label {
                            font-family: inherit !important;
                            font-size: 10px !important;
                            font-weight: 500 !important;
                            color: #0f766e !important;
                            letter-spacing: normal !important;
                            text-transform: none !important;
                            background: transparent !important;
                            border: none !important;
                            padding: 0 !important;
                            margin: 0 !important;
                        }
                        .edit-inventory-page .ai-price-hint-value {
                            font-family: inherit !important;
                            color: #008695 !important;
                            background: transparent !important;
                            padding: 0 !important;
                            margin: 0 !important;
                            font-size: 10px !important;
                            font-weight: 700 !important;
                            line-height: 1.4 !important;
                        }

                        /* Mobile-only fixed bottom submit bar */
                        .edit-inventory-page .mobile-submit-bar { display: none; }

                        /* Consistent vertical rhythm between all cards / sections */
                        .edit-inventory-page .card { margin-bottom: 10px !important; }

                        .edit-inventory-page .card.mb-4,
                        .edit-inventory-page .card.mb-3,
                        .edit-inventory-page .card.mb-2 { margin-bottom: 10px !important; }
                        .edit-inventory-page .row + .row,
                        .edit-inventory-page .card + .card { margin-top: 0 !important; }

                        @media (max-width: 767.98px) {
                            /* Slightly tighter on mobile so more content is visible */
                            .edit-inventory-page .card,
                            .edit-inventory-page .card.mb-4,
                            .edit-inventory-page .card.mb-3,
                            .edit-inventory-page .card.mb-2 { margin-bottom: 12px !important; }

                            /* Hide the global mobile top-bar on this page */
                            body:has(.edit-inventory-page) .mobile-topbar { display: none !important; }
                            body:has(.edit-inventory-page) .main-content { padding-top: 0 !important; }
                            body:has(.edit-inventory-page) .page-content { padding: 0 !important; }

                            /* Header becomes the fixed top header for this page */
                            .edit-inventory-page .create-inventory-sticky-header,
                            .create-inventory-sticky-header.create-inventory-sticky-header {
                                position: fixed !important;
                                top: 0 !important;
                                left: 0 !important;
                                right: 0 !important;
                                width: 100% !important;
                                padding: 16px 16px !important;
                                margin: 0 !important;
                                background: #f9fafb !important;
                                border-bottom: 1px solid #e5e7eb !important;
                                z-index: 1050;
                            }
                            .edit-inventory-page .create-inventory-sticky-header h4,
                            .create-inventory-sticky-header h4.create-inventory-sticky-header-h4 {
                                font-size: 15px !important;
                                letter-spacing: -0.01em !important;
                            }
                            .edit-inventory-page .create-inventory-sticky-header > div {
                                justify-content: flex-start !important;
                            }

                            /* Full-width content, offset for the fixed header */
                            .edit-inventory-page { padding-top: 56px !important; padding-bottom: 72px !important; }
                            /* Remove any extra top margin on the first section so Product Images hugs the header */
                            .edit-inventory-page form > .row:first-child { margin-top: 0 !important; }
                            .edit-inventory-page form > .row:first-child > .col-md-5 > .card:first-child,
                            .edit-inventory-page form > .row:first-child > [class*="col-"]:first-child > .card:first-child { margin-top: 0 !important; }
                            .edit-inventory-page > form,
                            .edit-inventory-page .container,
                            .edit-inventory-page .container-fluid { padding-left: 12px !important; padding-right: 12px !important; }
                        }
                        @media (max-width: 575px) {
                            .edit-inventory-page .create-inventory-sticky-header h4 {
                                font-size: 15px !important;
                            }
                        }
                        @media (max-width: 767.98px) {
                            /* Hide the header submit button on mobile */
                            .edit-inventory-page .create-inventory-sticky-header .request_btn { display: none !important; }

                            /* Reserve space so content isn't hidden behind the fixed bar */
                            .edit-inventory-page { padding-bottom: 68px !important; }

                            .edit-inventory-page .mobile-submit-bar {
                                display: flex !important;
                                align-items: center;
                                justify-content: center;
                                position: fixed;
                                left: 0; right: 0; bottom: 0;
                                padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));
                                background: #fff;
                                border-top: 1px solid #e2e8f0;
                                box-shadow: 0 -4px 12px rgba(15,23,42,0.06);
                                z-index: 1049;
                            }
                            .edit-inventory-page .mobile-submit-bar .request_btn {
                                width: 100%;
                                height: 40px !important;
                                justify-content: center;
                                font-size: 13px !important;
                                padding: 8px 16px !important;
                            }
                        }
                    `}</style>
                    <div className="create-inventory-sticky-header">
                        <div className="d-flex align-items-center justify-content-between mb-0 gap-2">
                            <div className="d-flex align-items-center" style={{ gap: '10px', minWidth: 0 }}>
                                <div
                                    className="back-btn"
                                    onClick={() => navigate(-1)}
                                    style={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '4px',
                                        border: '1px solid #e2e8f0',
                                        background: '#fff',
                                        flexShrink: 0,
                                    }}
                                >
                                    <IoMdArrowBack style={{ fontSize: '16px', color: '#475569' }} />
                                </div>
                                <h4 style={{ fontSize: '18px', fontWeight: 700, color: '#0f172a', margin: 0, letterSpacing: '-0.01em', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                    {id ? 'Update' : 'Add New'} Product
                                    {id && !isPublished && (
                                        <span className="draft-pill">Draft</span>
                                    )}
                                    {id && isAiGenerated && (
                                        <span className="ai-pill">
                                            <FaWandMagicSparkles style={{ fontSize: '10px' }} /> Powered by Getto AI
                                        </span>
                                    )}
                                </h4>
                            </div>

                            <Button
                                variant="primary"
                                type="submit"
                                form="product-form"
                                disabled={loading}
                                className="request_btn flex-shrink-0 no-focus-shadow"
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" />
                                        <span>Processing...</span>
                                    </>
                                ) : id ? (
                                    isPublished ? (
                                        <>
                                            <LuCheckCheck size={14} strokeWidth={2.5} />
                                            <span>Update Product</span>
                                        </>
                                    ) : (
                                        <>
                                            <FiPlus size={14} strokeWidth={2.5} />
                                            <span>Add to Inventory</span>
                                        </>
                                    )
                                ) : (
                                    <>
                                        <FiPlus size={14} strokeWidth={2.5} />
                                        <span>Add New Product</span>
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                    <div className="">
                        <div className="">
                            <div className=''>
                                <div className=''>
                                    <Form id="product-form" onSubmit={formik.handleSubmit}>

                                        {/* Show Formik validation errors for debugging */}
                                        {/* {Object.keys(formik.errors).length > 0 && (
                                            <pre style={{ color: 'red' }}>{JSON.stringify(formik.errors, null, 2)}</pre>
                                        )}

                                        {Object.keys(formik.values).length > 0 && (
                                            <pre style={{ color: 'blue' }}>{JSON.stringify(formik.values, null, 2)}</pre>
                                        )} */}


                                        {/* Basic Product Information Card */}
                                        <Row>
                                            {/* Left Side - Product Details */}
                                            <Col md={8} className="order-2 order-md-1">
                                                <Card className="mb-4 shadow-sm">
                                                    <Card.Header className="bg-light d-flex align-items-center justify-content-between" style={{ gap: 8 }}>
                                                        <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                            Product Details
                                                        </span>
                                                        {!id && (
                                                            <button
                                                                type="button"
                                                                className={`ai-fill-btn${aiFilling ? ' is-loading' : ''}`}
                                                                onClick={handleFillWithAi}
                                                                disabled={!canFillWithAi}
                                                                title={
                                                                    (formik.values.images?.length || 0) === 0
                                                                        ? 'Upload at least one image to enable AI fill'
                                                                        : 'Auto-fill details using AI'
                                                                }
                                                            >
                                                                <span className="ai-fill-icon">
                                                                    <RiSparkling2Fill />
                                                                </span>
                                                                <span className="ai-fill-label">
                                                                    {aiFilling ? 'Filling with AI…' : 'Fill with AI'}
                                                                </span>
                                                                <span className="ai-fill-sparkles" aria-hidden="true">
                                                                    <span className="ai-fill-spark ai-fill-spark-1" />
                                                                    <span className="ai-fill-spark ai-fill-spark-2" />
                                                                    <span className="ai-fill-spark ai-fill-spark-3" />
                                                                </span>
                                                            </button>
                                                        )}
                                                    </Card.Header>
                                                    <Card.Body className="p-4">
                                                        <Row>
                                                            <Col md={12}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Product Name <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter product name"
                                                                        name="productName"
                                                                        value={formik.values?.productName}
                                                                        onChange={formik.handleChange}
                                                                        isValid={formik.touched.productName && !formik.errors.productName}
                                                                        isInvalid={formik.touched.productName && !!formik.errors.productName}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.productName}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6} xs={6}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Price <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter price"
                                                                        name="price"
                                                                        value={formik.values?.price}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                                formik.setFieldValue("price", value);
                                                                            }
                                                                        }}
                                                                        isValid={formik.touched.price && !formik.errors.price}
                                                                        isInvalid={formik.touched.price && !!formik.errors.price}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.price}
                                                                    </Form.Control.Feedback>
                                                                    {(!id || (isAiGenerated && !isPublished)) && aiEstimatedPrice != null && (
                                                                        <button
                                                                            type="button"
                                                                            className="ai-price-hint"
                                                                            onClick={() => formik.setFieldValue("price", String(aiEstimatedPrice))}
                                                                            title="Click to use this price"
                                                                        >
                                                                            <span className="ai-price-hint-label">AI suggests</span>
                                                                            <span className="ai-price-hint-value">₹{aiEstimatedPrice}</span>
                                                                        </button>
                                                                    )}
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6} xs={6}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Discounted Price
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter discounted price"
                                                                        name="discountedPrice"
                                                                        value={formik.values?.discountedPrice}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                                formik.setFieldValue("discountedPrice", value);
                                                                            }
                                                                        }}
                                                                        isValid={formik.touched.discountedPrice && !formik.errors.discountedPrice}
                                                                        isInvalid={formik.touched.discountedPrice && !!formik.errors.discountedPrice}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.discountedPrice}
                                                                    </Form.Control.Feedback>
                                                                    {(!id || (isAiGenerated && !isPublished)) && aiEstimatedDiscountedPrice != null && (
                                                                        <button
                                                                            type="button"
                                                                            className="ai-price-hint"
                                                                            onClick={() => formik.setFieldValue("discountedPrice", String(aiEstimatedDiscountedPrice))}
                                                                            title="Click to use this discounted price"
                                                                        >
                                                                            <span className="ai-price-hint-label">AI suggests</span>
                                                                            <span className="ai-price-hint-value">₹{aiEstimatedDiscountedPrice}</span>
                                                                        </button>
                                                                    )}
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6} xs={6}>

                                                                {/* Product Color */}
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Product Color <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <div style={{ position: "relative" }}>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Select product color"
                                                                            name="color"
                                                                            value={formik.values.color}
                                                                            onChange={formik.handleChange}
                                                                            isValid={formik.touched.color && !formik.errors.color}
                                                                            isInvalid={formik.touched.color && !!formik.errors.color}
                                                                            onFocus={() => setColorPickerVisible(true)}
                                                                            cursor="pointer"
                                                                            className="rounded-input"
                                                                            style={{
                                                                                borderRadius: "8px",
                                                                                padding: "8px 10px",
                                                                                fontSize: "13px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {formik.errors.color}
                                                                        </Form.Control.Feedback>
                                                                        {colorPickerVisible && (
                                                                            <div style={{ position: "absolute", zIndex: 999 }} ref={colorPickerRef}>
                                                                                <SketchPicker color={selectedColor} onChange={handleColorChange} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Form.Group>

                                                            </Col>

                                                            <Col md={6} xs={6}> {/* Stock */}
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Total product Stock
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="--"
                                                                        name="stock"
                                                                        value={formik.values?.stock}
                                                                        onChange={formik.handleChange}
                                                                        isValid={formik.touched.stock && !formik.errors.stock}
                                                                        isInvalid={formik.touched.stock && !!formik.errors.stock}
                                                                        disabled
                                                                        className="rounded-input disabled_form_control"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                            backgroundColor: "#f8f9fa",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.stock}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Category */}
                                                            <Col md={6} xs={6}>
                                                                <Form.Group className="mb-4" id="field-selectedCategory">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Category <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <AsyncSelect
                                                                        loadOptions={loadOptionsCategory}
                                                                        defaultOptions={category}
                                                                        classNamePrefix="select"
                                                                        isClearable={true}
                                                                        placeholder={"Search Categories"}
                                                                        onChange={onCategoryChange}
                                                                        value={formik.values.selectedCategory}
                                                                        noOptionsMessage={customNoOptionsMessage}
                                                                        styles={{
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                border: "1px solid #ced4da",
                                                                                borderRadius: "8px",
                                                                                minHeight: "40px",
                                                                                fontSize: "13px",
                                                                            }),
                                                                        }}
                                                                    />
                                                                    <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                        {formik.touched.selectedCategory && formik.errors.selectedCategory}
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Sub-Category */}
                                                            <Col md={6} xs={6}>
                                                                <Form.Group className="mb-4" id="field-selectedSubCategory">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Sub-Category <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <Select
                                                                        key={formik.values.subCategoryId || 'no-cat'}
                                                                        options={subcategory}
                                                                        classNamePrefix="select"
                                                                        isClearable={true}
                                                                        placeholder={formik.values.subCategoryId !== '' ? "Search Sub Categories" : "Select a Category First"}
                                                                        onChange={onSubCategoryChange}
                                                                        value={formik.values.selectedSubCategory}
                                                                        noOptionsMessage={customNoOptionsMessage}
                                                                        isDisabled={formik.values.subCategoryId === ''}
                                                                        styles={{
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                border: "1px solid #ced4da",
                                                                                borderRadius: "8px",
                                                                                minHeight: "40px",
                                                                                fontSize: "13px",
                                                                                backgroundColor: formik.values.subCategoryId === '' ? '#f8f9fa' : '#fff',
                                                                            }),
                                                                        }}
                                                                    />
                                                                    <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                        {formik.touched.selectedSubCategory && formik.errors.selectedSubCategory}
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>

                                                            {/* Vendor */}
                                                            {user?.userType !== "Vendor" && (
                                                                <Col md={6} xs={6}>
                                                                    <Form.Group className="mb-4" id="field-selectedManufacture">
                                                                        <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                            Vendor <span style={{ color: '#dc2626' }}>*</span>
                                                                        </Form.Label>
                                                                        <AsyncSelect
                                                                            loadOptions={loadOptionsManufacture}
                                                                            defaultOptions={manufacturers}
                                                                            classNamePrefix="select"
                                                                            isClearable={true}
                                                                            placeholder="Search Vendors"
                                                                            onChange={onManufactureChange}
                                                                            value={formik.values.selectedManufacture}
                                                                            onMenuScrollToBottom={handleMenuScrollToBottomManufacture}
                                                                            noOptionsMessage={() =>
                                                                                hasMoreManufacture ? "Loading more options..." : "No more options"
                                                                            }
                                                                            styles={{
                                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    border: "1px solid #ced4da",
                                                                                    borderRadius: "8px",
                                                                                    minHeight: "40px",
                                                                                    fontSize: "13px",
                                                                                }),
                                                                            }}
                                                                        />
                                                                        <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                            {formik.touched.selectedManufacture && formik.errors.selectedManufacture}
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                            )}

                                                            {/* Brand */}
                                                            <Col md={6} xs={6}>
                                                                <Form.Group className="mb-4" id="field-selectedBrand">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Brand <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <AsyncSelect
                                                                        loadOptions={loadOptionsBrands}
                                                                        defaultOptions={brands}
                                                                        classNamePrefix="select"
                                                                        isClearable={true}
                                                                        placeholder={formik.values.manufacturerId !== '' ? "Search brands" : "Select a vendor First"}
                                                                        onChange={onBrandChange}
                                                                        value={formik.values.selectedBrand}
                                                                        onMenuScrollToBottom={handleMenuScrollToBottom}
                                                                        isDisabled={formik.values.manufacturerId === ''}
                                                                        noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                                                                        styles={{
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                border: "1px solid #ced4da",
                                                                                borderRadius: "8px",
                                                                                minHeight: "40px",
                                                                                fontSize: "13px",
                                                                                backgroundColor: formik.values.manufacturerId === '' ? '#f8f9fa' : '#fff',
                                                                            }),
                                                                        }}
                                                                    />
                                                                    <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                        {formik.touched.selectedBrand && formik.errors.selectedBrand}
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={12}>
                                                                <style>{`
                                                                    .product-desc-wrapper { display: block !important; }
                                                                    .product-desc-wrapper .ck-editor__editable_inline {
                                                                        min-height: 140px !important;
                                                                        max-height: 220px !important;
                                                                        height: auto !important;
                                                                        overflow-y: auto !important;
                                                                    }
                                                                    .product-desc-wrapper .ck-editor,
                                                                    .product-desc-wrapper .ck-editor__main,
                                                                    .product-desc-wrapper .ck-content { display: block !important; visibility: visible !important; }
                                                                `}</style>
                                                                <Form.Group className="mb-4 product-desc-wrapper" style={{ display: 'block' }}>
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px", display: 'block' }}>
                                                                        Product Description <span style={{ color: '#dc2626' }}>*</span>
                                                                    </Form.Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formik.values.description || ''}
                                                                        config={{
                                                                            placeholder: "Enter product description...",
                                                                        }}
                                                                        onReady={(editor) => {
                                                                            descriptionEditorRef.current = editor;
                                                                            // Force a reflow so the editor becomes visible even if a parent
                                                                            // reflow happened during initial mount.
                                                                            if (editor?.editing?.view?.change) {
                                                                                try {
                                                                                    editor.editing.view.change(() => { });
                                                                                } catch (_) { /* ignore */ }
                                                                            }
                                                                        }}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            formik.setFieldValue("description", data);
                                                                        }}
                                                                    />
                                                                    {formik.touched?.description && formik.errors?.description ? (
                                                                        <div className="custom-required" style={{ fontSize: "12px", color: "#DC3545" }}>
                                                                            Description is required
                                                                        </div>
                                                                    ) : null}
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>





                                            </Col>

                                            {/* Right Side - Product Images */}
                                            <Col md={4} className="d-flex flex-column order-1 order-md-2">
                                                {/* Product Images Card */}
                                                <Card id="field-images" className="mb-4 shadow-sm flex-grow-1 d-flex flex-column">
                                                    <Card.Header className="bg-light">
                                                        <span style={{ fontSize: "16px", fontWeight: "700" }}>
                                                            Product Images <span style={{ color: '#dc2626' }}>*</span>
                                                        </span>
                                                    </Card.Header>
                                                    <Card.Body
                                                        className={`p-4 d-flex flex-column product-images-body${isDraggingImages ? ' is-dragging' : ''}`}
                                                        onDragEnter={handleImageDragEnter}
                                                        onDragOver={handleImageDragOver}
                                                        onDragLeave={handleImageDragLeave}
                                                        onDrop={handleImageDrop}
                                                    >
                                                        {/* Compute the current thumbnail URL */}
                                                        {(() => {
                                                            let currentThumbnailUrl = "";

                                                            if (formik.values.thumbnailImageUrl) {
                                                                // try to match with old images
                                                                const oldMatch = oldImages?.find(img =>
                                                                    img.imageUrl.includes(formik.values.thumbnailImageUrl)
                                                                );
                                                                if (oldMatch) {
                                                                    currentThumbnailUrl = oldMatch.imageUrl;
                                                                }

                                                                // if not in old images, check newly added images
                                                                if (!currentThumbnailUrl && formik.values.images?.length > 0) {
                                                                    const newImg = formik.values.images.find(img =>
                                                                        typeof img === "string"
                                                                            ? img.includes(formik.values.thumbnailImageUrl)
                                                                            : false
                                                                    );
                                                                    if (newImg) {
                                                                        currentThumbnailUrl = newImg;
                                                                    }
                                                                }
                                                            }

                                                            const hasImages = (oldImages?.length || 0) > 0 || (formik.values.images?.length || 0) > 0;

                                                            if (!hasImages) {
                                                                return (
                                                                    <label
                                                                        htmlFor="fileInput"
                                                                        className="product-images-dropzone flex-grow-1"
                                                                    >
                                                                        <span className="product-images-dropzone-icon">
                                                                            <FiUploadCloud />
                                                                        </span>
                                                                        <span className="product-images-dropzone-title">Click to upload product images</span>
                                                                        <span className="product-images-dropzone-hint">PNG, JPG or WEBP · up to 5 MB each</span>
                                                                    </label>
                                                                );
                                                            }

                                                            return (
                                                                <div className="position-relative rounded mb-3 product-thumbnail-frame">
                                                                    {currentThumbnailUrl ? (
                                                                        <>
                                                                            <img
                                                                                src={currentThumbnailUrl}
                                                                                alt="Thumbnail"
                                                                                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain", display: "block" }}
                                                                            />
                                                                            <div
                                                                                className="position-absolute bottom-0 start-0 w-100 text-white text-center py-1"
                                                                                style={{ fontSize: "13px", background: "rgba(0,0,0,0.6)" }}
                                                                            >
                                                                                Thumbnail
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center h-100 text-muted"
                                                                            style={{ fontSize: "14px" }}
                                                                        >
                                                                            No thumbnail selected
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}


                                                        {/* Product Images Row (horizontal scroller) — hidden when empty (dropzone above handles that case) */}
                                                        {((oldImages?.length || 0) > 0 || (formik.values.images?.length || 0) > 0) && (
                                                        <div
                                                            className="d-flex gap-2 pb-2 align-items-center justify-content-start custom-scrollbar"
                                                            style={{
                                                                minHeight: "80px", // keeps row height
                                                                overflowX: "auto",
                                                                overflowY: "hidden",
                                                                whiteSpace: "nowrap",
                                                                border: "1px dashed #dee2e6",
                                                                borderRadius: "6px",
                                                                maxWidth: "100%", // ✅ ensures container doesn’t overflow
                                                            }}
                                                        >
                                                            <style>
                                                                {`
      .custom-scrollbar::-webkit-scrollbar {
        display: none;
      }
      .custom-scrollbar {
        -ms-overflow-style: none; /* IE/Edge */
        scrollbar-width: none; /* Firefox */
      }
    `}
                                                            </style>

                                                            {oldImages?.length > 0 || formik.values.images?.length > 0 ? (
                                                                <>
                                                                    {/* Old Images */}
                                                                    {oldImages?.map((image, i) => {
                                                                        const isThumbnail =
                                                                            formik.values.thumbnailImageUrl &&
                                                                            image?.imageUrl?.includes(formik.values.thumbnailImageUrl);

                                                                        return (
                                                                            <div
                                                                                key={`old-${i}`}
                                                                                className="position-relative"
                                                                                style={{
                                                                                    width: "80px",
                                                                                    height: "80px",
                                                                                    flex: "0 0 auto",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                {/* Click to select thumbnail */}
                                                                                <img
                                                                                    src={image?.imageUrl}
                                                                                    alt="product"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "6px",
                                                                                        border: isThumbnail ? "3px solid #00b1beff" : "1px solid #ddd",
                                                                                    }}
                                                                                    onClick={() => handleThumbnailSelect(i, true)}
                                                                                />

                                                                                {/* Remove button */}
                                                                                <IoClose
                                                                                    className="position-absolute top-0 end-0 m-1 bg-black rounded-circle shadow-sm"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                        color: "#ffffffff",
                                                                                        background: "#00000088",
                                                                                        padding: "2px"
                                                                                    }}
                                                                                    onClick={() => handleDeleteImage(i, true)}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    })}

                                                                    {/* New Images */}
                                                                    {formik.values.images?.map((image, index) => {
                                                                        const imageUrl =
                                                                            typeof image === "string" ? image : URL.createObjectURL(image);

                                                                        const isThumbnail =
                                                                            formik.values.thumbnailImageUrl &&
                                                                            (typeof image === "string"
                                                                                ? image.includes(formik.values.thumbnailImageUrl)
                                                                                : false);

                                                                        return (
                                                                            <div
                                                                                key={`new-${index}`}
                                                                                className="position-relative"
                                                                                style={{
                                                                                    width: "80px",
                                                                                    height: "80px",
                                                                                    flex: "0 0 auto",
                                                                                    cursor: "pointer",
                                                                                    border: isThumbnail ? "3px solid #00b1beff" : "1px solid #ddd",
                                                                                    borderRadius: "6px",
                                                                                    overflow: "hidden",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={imageUrl}
                                                                                    alt={`Uploaded ${index}`}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                    }}
                                                                                    onClick={() => handleThumbnailSelect(index, false)}
                                                                                />

                                                                                {/* Remove button */}
                                                                                <IoClose
                                                                                    className="position-absolute top-0 end-0 m-1 bg-black rounded-circle shadow-sm"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                        color: "#ffffffff",
                                                                                        background: '#00000088',
                                                                                        padding: "2px"
                                                                                    }}
                                                                                    onClick={() => handleDeleteImage(index)}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </>
                                                            ) : null}
                                                        </div>
                                                        )}


                                                        {/* Full-width Add More Button — only when at least one image exists (empty state uses the big dropzone above) */}
                                                        {((oldImages?.length || 0) > 0 || (formik.values.images?.length || 0) > 0) && (
                                                            <label
                                                                htmlFor="fileInput"
                                                                className="d-flex flex-column align-items-center justify-content-center text-center mt-3"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "40px",
                                                                    border: "2px dashed #000000ff",
                                                                    borderRadius: "10px",
                                                                    cursor: "pointer",
                                                                    color: "#000000ff",
                                                                    fontWeight: "500",
                                                                    transition: "all 0.3s ease",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.borderColor = "#000000ff";
                                                                    e.currentTarget.style.backgroundColor = "#ebebebff";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.borderColor = "#000000ff";
                                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                                }}
                                                            >
                                                                <span style={{ fontSize: "14px", }}>
                                                                    <FiPlus /> Add More Images
                                                                </span>
                                                            </label>
                                                        )}
                                                        <input
                                                            id="fileInput"
                                                            className="d-none"
                                                            type="file"
                                                            multiple
                                                            onChange={handleImageChange}
                                                            accept="image/*"
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>







                                        </Row>


                                        {/* Sizes Stocks Card */}
                                        {(() => {
                                            const sizesHasError = formik.submitCount > 0 && (typeof formik.errors?.sizes === 'string' || ((formik.values?.sizes?.length || 0) === 0 && formik.values?.selectedCategory !== '' && formik.values?.selectedSubCategory !== ''));
                                            return (
                                        <Card
                                            className="mb-4"
                                            id="field-sizes"
                                        >
                                            <Card.Header className={"bg-light"}>
                                                <Row className="flex-column">
                                                    <span style={{ fontSize: '18px', fontWeight: '700' }}>
                                                        Product Sizes / Stocks
                                                    </span>
                                                </Row>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {subsubcategory.length > 0 ? (
                                                    <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
                                                        {subsubcategory.slice().reverse().map((option, index) => {
                                                            const selectedSize = formik.values.sizes.find(s => s.size === option.label);

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="d-flex align-items-center"
                                                                    style={{
                                                                        width: '150px',
                                                                        gap: '8px',
                                                                        padding: '6px 10px',
                                                                        border: `1px solid ${sizesHasError ? '#dc2626' : '#e2e8f0'}`,
                                                                        borderRadius: '4px',
                                                                        backgroundColor: sizesHasError ? '#fef2f2' : '#f8fafc',
                                                                    }}
                                                                >
                                                                    {/* Checkbox */}
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        checked={!!selectedSize}
                                                                        onChange={(e) =>
                                                                            handleSizeCheckboxChange(option.label, e.target.checked)
                                                                        }
                                                                        className="custom-checkbox"
                                                                        style={{
                                                                            transform: 'scale(1)',
                                                                            marginRight: '4px',
                                                                        }}
                                                                    />

                                                                    {/* Size Label */}
                                                                    <span
                                                                        style={{
                                                                            flex: '1 1 auto',
                                                                            fontWeight: 600,
                                                                            fontSize: '11px',
                                                                            color: '#0f172a',
                                                                        }}
                                                                    >
                                                                        {option.label}
                                                                    </span>

                                                                    {/* Stock Input */}
                                                                    {selectedSize && (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={selectedSize.stock}
                                                                            placeholder="Qty"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                if (/^\d*$/.test(value))
                                                                                    handleProductSizeStockChangeByName(option.label, e);
                                                                            }}
                                                                            style={{
                                                                                width: '50px',
                                                                                minHeight: '26px',
                                                                                borderRadius: '4px',
                                                                                border: '1px solid #e2e8f0',
                                                                                textAlign: 'center',
                                                                                padding: '2px 4px',
                                                                                fontSize: '10px',
                                                                                backgroundColor: '#fff',
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (

                                                    <>




                                                        <p className="text-muted text-center my-3" style={{ fontSize: '11px' }}>
                                                            {formik.values.selectedSubCategory == '' ? 'Please select category and subcategory to load sizes' : 'No sizes found for the selected subcategory'}


                                                        </p>
                                                    </>



                                                )}
                                            </Card.Body>
                                        </Card>
                                            );
                                        })()}

                                        {/* Product Tags Card */}
                                        {tags.length > 0 && (
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-light">
                                                <Row className="flex-column">
                                                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                                                        Product Tags
                                                    </span>

                                                    {tags.length === 0 && formik.values.selectedSubCategory !== '' ? (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            No tags available for the selected subcategory
                                                        </span>
                                                    ) : tags.length === 0 ? (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            Select a subcategory to load available tags
                                                        </span>
                                                    ) : null}
                                                </Row>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {/* Check if subcategory is selected */}
                                                {formik.values.selectedSubCategory === '' ? (
                                                    <p className="text-muted text-center my-4" style={{ fontSize: '14px' }}>
                                                        Please select a subcategory to view available tags
                                                    </p>
                                                ) : tags.length > 0 ? (
                                                    <div className="d-flex flex-wrap gap-3 justify-content-start">

                                                        {tags.map((tag, index) => {
                                                            const isSelected = isTagSelected(tag.id);

                                                            return (
                                                                <div
                                                                    key={tag.id}
                                                                    className="d-flex flex-column align-items-center position-relative"
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                                                                    }}
                                                                    onClick={() => handleTagSelection(tag.id)}
                                                                >
                                                                    {/* Tag Image with Border */}
                                                                    <div
                                                                        className="rounded-circle overflow-hidden position-relative"
                                                                        style={{
                                                                            width: '80px',
                                                                            height: '80px',
                                                                            border: isSelected ? '3px solid #288d9dff' : '1px solid #dee2e6',
                                                                            padding: '2px',
                                                                            transition: 'all 0.3s ease',
                                                                            // boxShadow: isSelected ? '0 1px 1px #288d9dff' : 'none',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={tag.tagImageUrl}
                                                                            alt={tag.tagName}
                                                                            style={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '50%',
                                                                            }}
                                                                        />

                                                                        {/* Selection Checkmark */}
                                                                        {/* {isSelected && (
                                                                            <div
                                                                                className="position-absolute bg-success rounded-circle d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '20px',
                                                                                    height: '20px',
                                                                                    transform: 'translate(70%, -100%)',
                                                                                }}
                                                                            >
                                                                                <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>
                                                                                    ✓
                                                                                </span>
                                                                            </div>
                                                                        )} */}
                                                                    </div>

                                                                    {/* Tag Name */}
                                                                    <span
                                                                        className="mt-2 text-center"
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            fontWeight: isSelected ? '600' : '400',
                                                                            color: '#000000ff',
                                                                            maxWidth: '80px',
                                                                            wordWrap: 'break-word',
                                                                        }}
                                                                    >
                                                                        {tag.tagName}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <p className="text-muted text-center py-5" style={{ fontSize: '14px' }}>
                                                        No tags available for the selected subcategory
                                                    </p>
                                                )}

                                                {/* Selected Tags Summary */}
                                                {/* {formik.values.tags.length > 0 && (
                                                    <div className="mt-4 p-3 bg-light rounded">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#28a745' }}>
                                                                Selected Tags ({formik.values.tags.length}):
                                                            </span>
                                                            <div className="d-flex flex-wrap gap-2">
                                                                {tags
                                                                    .filter(tag => formik.values.tags.includes(tag.id))
                                                                    .map(tag => (
                                                                        <span
                                                                            key={tag.id}
                                                                            className="badge bg-success"
                                                                            style={{ fontSize: '12px' }}
                                                                        >
                                                                            {tag.tagName}
                                                                        </span>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}
                                            </Card.Body>
                                        </Card>
                                        )}




                                        {/* Specifications Card — hidden when the picked sub-category has no configured parameters */}
                                        {((specificationDrpdwn?.length || 0) > 0 || (formik.values.specs?.length || 0) > 0) && (
                                        <Card className="mb-4">
                                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: '16px', fontWeight: '700' }}>Specifications</span>
                                                <Button
                                                    onClick={handleSpecificationAdd}
                                                    variant="outline-dark"
                                                    className="subcategory-add-button"
                                                    disabled={formik.values.selectedCategory === '' || formik.values.selectedSubCategory === ''} // ✅ disable Add Specification button
                                                >
                                                    <FiPlus /> Add Specification
                                                </Button>
                                            </Card.Header>

                                            <div className="specifications-wrapper">
                                                {/* Check if category + subcategory are selected */}
                                                {formik.values.selectedCategory === '' || formik.values.selectedSubCategory === '' ? (
                                                    <div className="text-center my-5 py-4">
                                                        <p className="text-muted" style={{ fontSize: '14px' }}>
                                                            Please select category and subcategory to add specifications
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {/* Specifications List */}
                                                        {formik?.values?.specs.length > 0 ? (
                                                            formik.values.specs.map((item, index) => {
                                                                // Get a list of already selected values
                                                                const selectedValues = formik.values.specs.map((spec) => spec.name);

                                                                // Filter the options to exclude already selected values
                                                                const availableSpecsOptions = specificationDrpdwn.filter(
                                                                    (option) => !selectedValues.includes(option.label) || option.label === item.name
                                                                );

                                                                return (
                                                                    <div key={index} className="specification-row mb-4 p-3 border rounded">
                                                                        <div className="d-flex align-items-start justify-content-between">
                                                                            <div className="d-flex align-items-start gap-4 flex-grow-1">
                                                                                {/* Specification Dropdown */}
                                                                                <Form.Group className="specification-select-group flex-grow-1">
                                                                                    <Form.Label className="form-label-custom d-block mb-2">
                                                                                        Specification
                                                                                    </Form.Label>
                                                                                    <Select
                                                                                        placeholder='Select Specification'
                                                                                        options={availableSpecsOptions}
                                                                                        value={specificationDrpdwn.find(option => option.label === item.name)}
                                                                                        onChange={(selectedOption) => handleProductSpecificationChange(index, selectedOption)}
                                                                                        theme={(theme) => ({
                                                                                            ...theme,
                                                                                            borderRadius: "8px",
                                                                                            colors: {
                                                                                                ...theme.colors,
                                                                                                primary: '#779be1',
                                                                                            },
                                                                                        })}
                                                                                        styles={{
                                                                                            menu: (baseStyles) => ({
                                                                                                ...baseStyles,
                                                                                                zIndex: 9999,
                                                                                            }),
                                                                                            control: (provided, state) => ({
                                                                                                ...provided,
                                                                                                border: "1px solid #ddd",
                                                                                                padding: '8px 12px',
                                                                                                minHeight: '48px',
                                                                                                borderRadius: '8px',
                                                                                                boxShadow: 'none',
                                                                                                '&:hover': {
                                                                                                    borderColor: '#779be1'
                                                                                                },
                                                                                                borderColor: state.isFocused ? '#779be1' : '#ddd',
                                                                                            }),
                                                                                            placeholder: (provided) => ({
                                                                                                ...provided,
                                                                                                color: '#6c757d',
                                                                                            }),
                                                                                        }}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>

                                                                                {/* Specification Value Input */}
                                                                                {item.name && (
                                                                                    <Form.Group className="specification-value-group flex-grow-1">
                                                                                        <Form.Label className="form-label-custom d-block mb-2">
                                                                                            {specificationDrpdwn.find(option => option.label === item.name)?.label}
                                                                                        </Form.Label>
                                                                                        <div className="d-flex align-items-center gap-2">
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                name={`specs[${index}].value`}
                                                                                                value={item.value}
                                                                                                onChange={formik.handleChange}
                                                                                                isValid={formik.touched.specs?.[index]?.value && !formik.errors.specs?.[index]?.value}
                                                                                                isInvalid={formik.touched.specs?.[index]?.value && !!formik.errors.specs?.[index]?.value}
                                                                                                className="specification-input"
                                                                                                style={{
                                                                                                    height: '48px',
                                                                                                    padding: '12px 16px'
                                                                                                }}
                                                                                                placeholder={`Enter ${specificationDrpdwn.find(option => option.label === item.name)?.label}`}
                                                                                                required
                                                                                            />
                                                                                        </div>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            {formik.errors.specs?.[index]?.value}
                                                                                        </Form.Control.Feedback>
                                                                                    </Form.Group>
                                                                                )}
                                                                            </div>

                                                                            {/* Delete Button */}
                                                                            <div className="delete-section ms-3" style={{ marginTop: '32px' }}>
                                                                                <MdDeleteOutline
                                                                                    role='button'
                                                                                    onClick={() => handleDeleteSpecific(index)}
                                                                                    style={{
                                                                                        fontSize: "24px",
                                                                                        color: "#dc3545",
                                                                                    }}
                                                                                    className="delete-spec-btn"
                                                                                    title="Delete specification"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="text-center my-5 py-4">
                                                                <p className="text-muted">
                                                                    Add new specification
                                                                </p>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>


                                        </Card>
                                        )}



                                        {/* Product Variants Card */}
                                        <Card className="mb-4 shadow-sm" style={{ display: 'none' }}>
                                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: '16px', fontWeight: '700' }}>Product Variants</span>
                                                <Button
                                                    onClick={handleShow}
                                                    variant="outline-dark"
                                                    className="subcategory-add-button"
                                                    disabled={formik.values.selectedCategory === '' || formik.values.selectedSubCategory === ''} // ✅ disable Add Variant button if not selected
                                                >
                                                    <FiPlus /> Add Variant
                                                </Button>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {/* Check if category + subcategory are selected */}
                                                {formik.values.selectedCategory === '' || formik.values.selectedSubCategory === '' ? (
                                                    <p className="text-muted text-center my-5" style={{ fontSize: '14px' }}>
                                                        Please select category and subcategory to add variants
                                                    </p>
                                                ) : (
                                                    <>
                                                        {/* Variants List */}
                                                        {formik.values.variants.length > 0 ? (
                                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                                {formik.values.variants.map((variant, index) => (
                                                                    <div key={index} className="d-flex align-items-center me-3">
                                                                        <Button className="request_btn">
                                                                            <div
                                                                                className="color_code"
                                                                                style={{ backgroundColor: variant.variantColor }}
                                                                            ></div>
                                                                            Variant {index + 1}
                                                                        </Button>
                                                                        <MdDeleteOutline
                                                                            role="button"
                                                                            onClick={() => handleDeleteVariant(index)}
                                                                            style={{
                                                                                fontSize: "25px",
                                                                                color: "red",
                                                                                marginLeft: "10px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p className="text-muted text-center my-5">
                                                                Add new variant
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </Card.Body>
                                        </Card>









                                    </Form>
                                    {/* Add varient */}
                                    <Modal
                                        show={show}
                                        onHide={handleClose}
                                        centered
                                        className='modal_create'
                                        size='lg'
                                        backdrop="static"
                                    >
                                        <Form onSubmit={variantformik.handleSubmit}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Add Variant</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className='modal_content_wrapper'>
                                                    <div className='row'>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Product Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantName'
                                                                    value={variantformik.values?.variantName}
                                                                    onChange={variantformik.handleChange}
                                                                    isValid={variantformik.touched.variantName && !variantformik.errors.variantName}
                                                                    isInvalid={variantformik.touched.variantName && !!variantformik.errors.variantName}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantName}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                                <Form.Label>Color</Form.Label>
                                                                <div style={{ position: 'relative' }}>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder=""
                                                                        name='variantColor'
                                                                        value={variantformik.values.variantColor}
                                                                        onChange={variantformik.handleChange}
                                                                        isValid={variantformik.touched.variantColor && !variantformik.errors.variantColor}
                                                                        isInvalid={variantformik.touched.variantColor && !!variantformik.errors.variantColor}
                                                                        onFocus={() => setColorPickerVisible(true)}
                                                                        // onBlur={() => setColorPickerVisible(false)}
                                                                        readOnly
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{variantformik.errors.variantColor}</Form.Control.Feedback>

                                                                    {colorPickerVisible && (
                                                                        <div style={{ position: 'absolute', zIndex: 999 }} ref={colorPickerRef}>
                                                                            <SketchPicker
                                                                                color={selectedColorVariant}
                                                                                onChange={handleColorVaiantChange}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                                <Form.Label>Stock</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantStock'
                                                                    value={variantformik.values?.variantStock}
                                                                    onChange={variantformik.handleChange}
                                                                    isValid={variantformik.touched.variantStock && !variantformik.errors.variantStock}
                                                                    isInvalid={variantformik.touched.variantStock && !!variantformik.errors.variantStock}
                                                                    disabled
                                                                    className='disabled_form_control'
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantStock}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Price</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantPrice'
                                                                    value={variantformik.values?.variantPrice}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow only numbers and prevent negative values
                                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                                            variantformik.setFieldValue("variantPrice", value);
                                                                        }
                                                                    }}
                                                                    isValid={variantformik.touched.variantPrice && !variantformik.errors.variantPrice}
                                                                    isInvalid={variantformik.touched.variantPrice && !!variantformik.errors.variantPrice}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantPrice}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Discount Price</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantDiscountedPrice'
                                                                    value={variantformik.values?.variantDiscountedPrice}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow only numbers and prevent negative values
                                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                                            variantformik.setFieldValue("variantDiscountedPrice", value);
                                                                        }
                                                                    }}
                                                                    isValid={variantformik.touched.variantDiscountedPrice && !variantformik.errors.variantDiscountedPrice}
                                                                    isInvalid={variantformik.touched.variantDiscountedPrice && !!variantformik.errors.variantDiscountedPrice}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantDiscountedPrice}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-12'>
                                                            <Form.Label>Product Images</Form.Label>
                                                            <Form.Group className="br_border mb-3">
                                                                <label htmlFor="fileInputVariant" className="custom-file-upload-product">
                                                                    <img src={upload} className='upload_icon img-fluid' alt='Upload' />
                                                                </label>
                                                                <input
                                                                    id="fileInputVariant"
                                                                    className='file_type'
                                                                    type="file"
                                                                    multiple
                                                                    onChange={handleImageVariantChange}
                                                                />
                                                                <div className="d-flex flex-row align-items-center justify-content-start gap-3">
                                                                    <div className="uploaded-images">
                                                                        {oldVariantImages?.map((image, i) =>
                                                                            <div className='pos-rel' key={i}>
                                                                                <img src={image?.imageUrl} alt="product" className="uploaded-image" />
                                                                                <IoClose className='icon_close' onClick={() => deleteImage(i)} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {/* Display uploaded images */}
                                                                    <div className="uploaded-images">
                                                                        {variantformik.values.variantImages?.map((image, index) => (
                                                                            <div className='pos-rel' key={index}>
                                                                                <img key={index} src={image} alt={`Uploaded ${index}`} className="uploaded-image" />
                                                                                <IoClose className='icon_close' onClick={() => handleDeleteVariantImage(index)} />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{variantformik.touched.variantImages && variantformik.errors.variantImages}</div>

                                                            </Form.Group>
                                                        </div>
                                                        {/* Add Size Fields */}
                                                        <div className='col-lg-12'>
                                                            <div className='row align-items-center btn_wrapper_add_size'>
                                                                <div className='col-lg-8'>
                                                                    {variantformik.values.variantSizes[0].sizes.map((item, index) => {

                                                                        const isFirstItem = index === 0;
                                                                        const isLastItem = index === formik.values.sizes.length - 1; // Check if this is the last item
                                                                        const shouldApplyRightBorder = ((index + 1) % 3 !== 0) && !isLastItem; // Apply br_right only if not the 3rd item and not the last item
                                                                        // Get a list of already selected values
                                                                        const selectedValues = variantformik.values.variantSizes[0].sizes.map((size) => size.size);

                                                                        // Filter the options to exclude already selected values
                                                                        const availableSizeOptions = subsubcategory.filter(
                                                                            (option) => !selectedValues.includes(option.label) || option.label === item.size
                                                                        );
                                                                        return (
                                                                            <div key={index} className='d-flex align-items-center mt-3'>

                                                                                <div className='d-flex align-items-baseline'>
                                                                                    <Form.Group className="mb-3 me-3">
                                                                                        {index === 0 && <Form.Label>Size</Form.Label>}
                                                                                        <Select
                                                                                            placeholder='Select Size'
                                                                                            options={availableSizeOptions}
                                                                                            value={subsubcategory.find(option => option.value === item.size)} // Select value for current size
                                                                                            onChange={(selectedOption) => handleSizeSelectChange(index, selectedOption)} // Custom handler for Select
                                                                                            theme={(theme) => ({
                                                                                                ...theme,
                                                                                                borderRadius: "0 10px 10px 10px",
                                                                                                colors: {
                                                                                                    ...theme.colors,
                                                                                                    primary: '#779be1',
                                                                                                },
                                                                                            })}
                                                                                            styles={{
                                                                                                menu: (baseStyles) => ({
                                                                                                    ...baseStyles,
                                                                                                    zIndex: 9999,
                                                                                                }),
                                                                                                control: (provided) => ({
                                                                                                    ...provided,
                                                                                                    border: "1px solid #a7a7a7",
                                                                                                    padding: '6px',
                                                                                                    width: '220px'
                                                                                                }),
                                                                                            }}
                                                                                            required
                                                                                        />
                                                                                    </Form.Group>

                                                                                    <Form.Group className="mb-3 me-3">
                                                                                        {index === 0 && <Form.Label>Stock</Form.Label>}
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            placeholder="Enter stock"
                                                                                            name='stock'
                                                                                            value={item.stock}
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;

                                                                                                if (/^\d*$/.test(value)) {
                                                                                                    handleSizeStockChange(index, e);
                                                                                                }
                                                                                            }}
                                                                                            required
                                                                                        />
                                                                                    </Form.Group>
                                                                                </div>

                                                                                <MdDeleteOutline
                                                                                    role='button'
                                                                                    onClick={() => handleDeleteSizeStock(index)}
                                                                                    style={{ fontSize: "25px", color: "red" }}
                                                                                    className={`delete_size_btn ${index === 0 ? 'mt-2' : 'mb-4'}`}
                                                                                />
                                                                                {/* <Button variant="danger" className={`delete_size_btn ${index === 0 ? 'mt-2' : 'mb-4'}`} >
                                                                            <IoClose />
                                                                        </Button> */}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                                {variantformik.values.variantSizes[0].sizes.length > 0 && (
                                                                    <div className='br_bottom'></div>
                                                                )}
                                                                <div className='col-lg-12'>
                                                                    <div className='store_details_wrapper_custom'>
                                                                        <div className='form_wrapper'>
                                                                            <div className='row'>
                                                                                {variantformik.values.specs.map((item, index) => {
                                                                                    const isLastItem = index === variantformik.values.specs.length - 1; // Check if this is the last item
                                                                                    const shouldApplySpecRightBorder = ((index + 1) % 3 !== 0) && !isLastItem; // Apply br_right only if not the 3rd item and not the last item

                                                                                    // Get a list of already selected values
                                                                                    const selectedValues = variantformik.values.specs.map((spec) => spec.name);

                                                                                    // Filter the options to exclude already selected values
                                                                                    const availableSpecsOptions = specificationDrpdwn.filter(
                                                                                        (option) => !selectedValues.includes(option.label) || option.label === item.name
                                                                                    );
                                                                                    return (
                                                                                        <div key={index} className='d-flex align-items-center mt-3 gap-2'>

                                                                                            <div className='d-flex align-items-baseline'>
                                                                                                <Form.Group className="mb-3 me-3">
                                                                                                    <Form.Label>Specifications</Form.Label>
                                                                                                    <Select
                                                                                                        placeholder='Select Specification'
                                                                                                        options={availableSpecsOptions}
                                                                                                        value={specificationDrpdwn.find(option => option.value === item.name)} // Select value for current size
                                                                                                        onChange={(selectedOption) => handleVariantSpecificationChange(index, selectedOption)} // Custom handler for Select
                                                                                                        theme={(theme) => ({
                                                                                                            ...theme,
                                                                                                            borderRadius: "0 10px 10px 10px",
                                                                                                            colors: {
                                                                                                                ...theme.colors,
                                                                                                                primary: '#779be1',
                                                                                                            },
                                                                                                        })}
                                                                                                        styles={{
                                                                                                            menu: (baseStyles) => ({
                                                                                                                ...baseStyles,
                                                                                                                zIndex: 9999,
                                                                                                            }),
                                                                                                            control: (provided) => ({
                                                                                                                ...provided,
                                                                                                                border: "1px solid #a7a7a7",
                                                                                                                padding: '6px',
                                                                                                                width: '220px'
                                                                                                            }),
                                                                                                        }}
                                                                                                        required
                                                                                                    />
                                                                                                </Form.Group>

                                                                                                {/* Conditionally render the input field based on whether a specification is selected */}
                                                                                                {item.name && (
                                                                                                    <Form.Group className="mb-3" controlId={`specs.${index}.value`}>
                                                                                                        {/* Use the selected specification label as the input label */}
                                                                                                        <Form.Label>{specificationDrpdwn.find(option => option.label === item.name)?.label}</Form.Label>
                                                                                                        <div className='form_del_control'>
                                                                                                            <Form.Control
                                                                                                                type="text"
                                                                                                                name={`specs[${index}].value`}
                                                                                                                value={item.value}
                                                                                                                onChange={variantformik.handleChange}
                                                                                                                isValid={variantformik.touched.specs?.[index]?.value && !variantformik.errors.specs?.[index]?.value}
                                                                                                                isInvalid={variantformik.touched.specs?.[index]?.value && !!variantformik.errors.specs?.[index]?.value}
                                                                                                                required
                                                                                                            />
                                                                                                        </div>
                                                                                                        <Form.Control.Feedback type="invalid">
                                                                                                            {formik.errors.specs?.[index]?.value}
                                                                                                        </Form.Control.Feedback>
                                                                                                    </Form.Group>
                                                                                                )}
                                                                                            </div>

                                                                                            <MdDeleteOutline
                                                                                                role='button'
                                                                                                onClick={() => handleVariantDeleteSpecific(index)}
                                                                                                style={{ fontSize: "25px", color: "red" }}
                                                                                                className={`delete_size_btn mt-4`}
                                                                                            />
                                                                                        </div>
                                                                                    )


                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                {variantformik.values.specs.length > 0 && (
                                                                    <div className='br_bottom'></div>
                                                                )}
                                                                <div className='btn_groups'>
                                                                    <Button className="request_btn" onClick={handleAddSize}>
                                                                        <BiPlus /> Add Size
                                                                    </Button>

                                                                    <Button className="request_btn" onClick={handleVariantSpecificationAdd}>
                                                                        <BiPlus /> Add Specification
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>



                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button className='cancle_btn' onClick={handleClose}>
                                                    Cancel
                                                </Button>
                                                <Button className='submit_btn' type='submit'>
                                                    {loading ? "Loading" : id ? "Update Variant" : "Create Variant"}
                                                </Button>
                                            </Modal.Footer>
                                        </Form>
                                    </Modal>
                                    {/* Add varient */}

                                    <Modal show={showVariantSpecification} onHide={handleSpecificationClose} centered className='modal_create' size='lg' backdrop="static">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Add Specification</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className='modal_content_wrapper'>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Add Specification</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        onChange={(e) => setVariantSpecificChange(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button className='cancle_btn' onClick={handleSpecificationClose}>Cancel</Button>
                                            <Button className='submit_btn' onClick={handleVairantSpecificSubmit}>Submit</Button>
                                        </Modal.Footer>
                                    </Modal>

                                </div>
                            </div>
                        </div>

                    </div >

                    {/* Mobile-only fixed submit bar at the bottom */}
                    <div className="mobile-submit-bar">
                        <Button
                            variant="primary"
                            type="submit"
                            form="product-form"
                            disabled={loading}
                            className="request_btn no-focus-shadow"
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" />
                                    <span>Processing...</span>
                                </>
                            ) : id ? (
                                isPublished ? (
                                    <>
                                        <LuCheckCheck size={14} strokeWidth={2.5} />
                                        <span>Update Product</span>
                                    </>
                                ) : (
                                    <>
                                        <FiPlus size={14} strokeWidth={2.5} />
                                        <span>Add to Inventory</span>
                                    </>
                                )
                            ) : (
                                <>
                                    <FiPlus size={14} strokeWidth={2.5} />
                                    <span>Add New Product</span>
                                </>
                            )}
                        </Button>
                    </div>
                </div >

            )}

            {/* AI-fill error modal — mirrors the reject-order modal style */}
            <Modal
                show={aiErrorModal.show}
                onHide={closeAiErrorModal}
                centered
                dialogClassName="ai-fill-error-modal"
                contentClassName="ai-fill-error-modal-content"
            >
                <style>{`
                    .ai-fill-error-modal { max-width: 420px; }
                    .ai-fill-error-modal-content {
                        border: none !important;
                        border-radius: 14px !important;
                        box-shadow: 0 20px 50px rgba(15,23,42,0.18) !important;
                        overflow: hidden !important;
                    }
                    @media (max-width: 480px) {
                        .ai-fill-error-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
                    }
                `}</style>
                <Modal.Body style={{ padding: '24px 22px 20px', textAlign: 'center' }}>
                    <div
                        style={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 14,
                        }}
                    >
                        <IoMdCloseCircleOutline size={30} />
                    </div>
                    <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 8px', letterSpacing: '-0.01em' }}>
                        AI could not process your images
                    </h5>
                    <p style={{ fontSize: 12.5, color: '#475569', margin: 0, lineHeight: 1.55 }}>
                        {aiErrorModal.message}
                    </p>
                    {(aiErrorModal.code || aiErrorModal.confidence) && (
                        <div style={{ display: 'inline-flex', flexWrap: 'wrap', justifyContent: 'center', gap: 6, marginTop: 12 }}>
                            {aiErrorModal.code && (
                                <span style={{ padding: '3px 9px', borderRadius: 999, background: '#fef2f2', color: '#b91c1c', fontSize: 10, fontWeight: 700, letterSpacing: '0.02em' }}>
                                    {aiErrorModal.code}
                                </span>
                            )}
                            {aiErrorModal.confidence && (
                                <span style={{ padding: '3px 9px', borderRadius: 999, background: '#fef3c7', color: '#92400e', fontSize: 10, fontWeight: 700, letterSpacing: '0.02em', textTransform: 'capitalize' }}>
                                    Confidence: {aiErrorModal.confidence}
                                </span>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer style={{ padding: '12px 18px', borderTop: '1px solid #eef2f7', justifyContent: 'stretch' }}>
                    <button
                        type="button"
                        onClick={closeAiErrorModal}
                        style={{
                            flex: 1,
                            height: 40,
                            borderRadius: 8,
                            border: 0,
                            background: '#0f172a',
                            color: '#fff',
                            fontSize: 13,
                            fontWeight: 700,
                            cursor: 'pointer',
                            letterSpacing: '0.01em',
                            transition: 'all 0.15s ease',
                        }}
                    >
                        Got it
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default CreateInventory